(function (root, factory) {
  'use strict';
  var exported = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = exported;
  root.FBGroupGifts = exported;
  if (root.document && root.FBRemindersAPI) {
    var page = root.document.getElementById('fb-reminders-app');
    if (page) exported.init(page);
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';
  var activeController = null;
  var GROUP_STATES = {
    draft: 'Ready to invite',
    open: 'Collecting contributions',
    closed: 'Contributions closed',
    purchasing: 'Checking your order',
    completed: 'Gift ordered',
    cancelled: 'Group cancelled'
  };
  var PAYMENT_STATES = {
    initiated: 'Payment started · not collected',
    pending: 'Payment pending · not spendable',
    succeeded: 'Contribution received',
    failed: 'Payment unsuccessful',
    refund_pending: 'Refund in progress · not spendable',
    refunded: 'Refund confirmed',
    disputed: 'Payment on hold · not spendable'
  };
  var PURCHASE_STATES = {
    preparing: 'Preparing your order',
    pending: 'Checking your order',
    completed: 'Gift ordered',
    failed: 'Order not completed',
    review_required: 'Your order needs attention'
  };
  function el(tag, cls, text) {
    var e = root.document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function append(parent) {
    Array.prototype.slice.call(arguments, 1).forEach(function (child) {
      if (child) parent.appendChild(child);
    });
    return parent;
  }
  function button(text, action, secondary) {
    var b = el(
      'button',
      'fb-group__button' + (secondary ? ' fb-group__button--secondary' : ''),
      text
    );
    b.type = 'button';
    if (action) b.addEventListener('click', action);
    return b;
  }
  function link(text, href, cls) {
    var a = el('a', cls || '', text);
    a.href = href;
    return a;
  }
  function money(cents) {
    return Number.isSafeInteger(cents) && cents >= 0
      ? new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD',
          maximumFractionDigits: cents % 100 ? 2 : 0
        }).format(cents / 100)
      : 'Not available';
  }
  function cents(value) {
    if (!/^\d+(?:\.\d{1,2})?$/.test(String(value))) return null;
    var parts = String(value).split('.');
    var result =
      Number(parts[0]) * 100 + Number((parts[1] || '').padEnd(2, '0'));
    return Number.isSafeInteger(result) && result > 0 ? result : null;
  }
  function date(value, time) {
    var d = new Date(time ? value : value + 'T12:00:00Z');
    if (!Number.isFinite(d.getTime())) return 'Date to be confirmed';
    return new Intl.DateTimeFormat('en-AU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'Australia/Melbourne',
      ...(time ? { hour: 'numeric', minute: '2-digit' } : {})
    }).format(d);
  }
  function uniqueKey() {
    if (root.crypto && root.crypto.randomUUID) return root.crypto.randomUUID();
    if (!root.crypto || !root.crypto.getRandomValues)
      throw new Error(
        'Your browser cannot securely start this action. Please update it and try again.'
      );
    var bytes = new Uint8Array(24);
    root.crypto.getRandomValues(bytes);
    return Array.prototype.map
      .call(bytes, function (b) {
        return b.toString(16).padStart(2, '0');
      })
      .join('');
  }
  function groupUrl(id) {
    return '/pages/reminders?reminder_view=group&id=' + encodeURIComponent(id);
  }
  function groupListInfo(group) {
    var projected = root.FBGroupGiftsJourney && root.FBGroupGiftsJourney.view(group);
    if (projected && projected.progressAvailable) {
      var repair = group.state === 'draft' && group.journey.status === 'expired' && group.journey.primaryAction && group.journey.primaryAction.id === 'edit_group' && group.journey.primaryAction.enabled === true;
      return { bucket: !repair && ['ordered', 'cancelled', 'expired'].includes(group.journey.status) ? 'past' : 'active', status: repair ? 'Update group dates' : projected.statusLabel };
    }
    return { bucket: ['completed', 'cancelled'].includes(group.state) ? 'past' : 'unknown', status: ['completed', 'cancelled'].includes(group.state) ? GROUP_STATES[group.state] : 'Check status' };
  }
  function groupListSections(groups) {
    var result = { active: [], past: [], unknown: [] };
    groups.forEach(function (group) { result[groupListInfo(group).bucket].push(group); });
    return result;
  }
  function groupListRow(group) {
    var row = el('article', 'fb-group__gift-row'), content = el('div', 'fb-group__gift-row-content');
    var occasion = group.occasion || {}, kind = { BIRTHDAY: 'Birthday', CHRISTMAS: 'Christmas', ANNIVERSARY: 'Anniversary', LEAVING: 'Leaving gift', OTHER: 'Occasion' }[occasion.type] || 'Occasion';
    append(content, el('strong', 'fb-group__gift-name', group.name),
      el('p', 'fb-group__gift-occasion', (group.recipientName ? group.recipientName + ' · ' : '') + kind + ' · ' + date(occasion.occursOn)),
      el('p', 'fb-group__muted', (group.role === 'organiser' ? 'You’re organising' : 'You’re contributing') + ' · ' + groupListInfo(group).status));
    var open = link('Open gift →', groupUrl(group.id), 'fb-group__gift-open'); open.setAttribute('aria-label', 'Open ' + group.name);
    append(row, content, open); return row;
  }
  function safeProductUrl(url) {
    try {
      var u = new URL(url, root.location.origin);
      return u.origin === root.location.origin &&
        /^\/products\/[a-z0-9][a-z0-9-]*$/.test(u.pathname)
        ? u.href
        : null;
    } catch (_) {
      return null;
    }
  }
  function safeImage(url) {
    try {
      var u = new URL(url, root.location.origin);
      return u.protocol === 'https:' &&
        (u.hostname === 'cdn.shopify.com' || u.origin === root.location.origin)
        ? u.href
        : null;
    } catch (_) {
      return null;
    }
  }
  function safeCheckout(url, kind) {
    try {
      var u = new URL(url);
      if (u.protocol !== 'https:' || u.username || u.password) return null;
      if (kind === 'contribution')
        return u.hostname === 'checkout.stripe.com' ? u.href : null;
      return (u.hostname === 'figandbloom.com' ||
        u.hostname === 'checkout.shopify.com') &&
        /\/(?:checkouts?|cart|c)\//.test(u.pathname)
        ? u.href
        : null;
    } catch (_) {
      return null;
    }
  }
  function owningForm(node) {
    while (node && node.tagName !== 'FORM') node = node.parentNode;
    return node;
  }
  function formControls(form) {
    return ['input', 'select', 'textarea'].reduce(function (all, tag) { return all.concat(Array.from(form.querySelectorAll(tag))); }, []);
  }
  function fieldError(input, message) {
    var wrap = input.parentNode;
    if (!wrap) return;
    var error = wrap.querySelector('.fb-group__field-error');
    if (!error) {
      error = el('small', 'fb-group__field-error fb-group__error');
      error.id = (input.id || 'group-' + input.name) + '-error'; append(wrap, error);
    }
    error.textContent = message || ''; error.hidden = !message;
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    var described = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (described.indexOf(error.id) < 0) described.push(error.id);
    input.setAttribute('aria-describedby', described.join(' '));
  }
  function clearFormErrors(form) {
    formControls(form).forEach(function (input) { if (input.getAttribute('aria-invalid') === 'true') fieldError(input, ''); });
    var summary = form.querySelector('.fb-group__error-summary');
    if (summary) { summary.textContent = ''; summary.hidden = true; }
  }
  function formError(form, message, names) {
    var summary = form.querySelector('.fb-group__error-summary');
    if (!summary) {
      summary = el('p', 'fb-group__error-summary fb-group__error');
      summary.setAttribute('role', 'alert'); summary.tabIndex = -1;
      form.insertBefore(summary, form.firstChild);
    }
    summary.hidden = false; summary.textContent = message;
    (names || []).forEach(function (name) {
      var input = form.querySelector('[name="' + name + '"]');
      if (input) fieldError(input, message);
    });
    summary.focus();
  }
  function wireFieldValidation(input, labelText) {
    input.addEventListener('invalid', function (event) {
      var owner = owningForm(input);
      if (!owner) return;
      event.preventDefault();
      formError(owner, labelText + ': ' + (input.validationMessage || 'Check this field.'), [input.name]);
    });
    function clearEditedError() {
      if (input.getAttribute('aria-invalid') !== 'true') return;
      fieldError(input, '');
      var owner = owningForm(input);
      if (owner && !formControls(owner).some(function (control) { return control.getAttribute('aria-invalid') === 'true'; })) clearFormErrors(owner);
    }
    input.addEventListener('input', clearEditedError);
    input.addEventListener('change', clearEditedError);
  }
  function field(form, name, labelText, type, value, options) {
    options = options || {};
    var wrap = el('div', 'fb-group__field');
    var id = 'group-' + name;
    var label = el('label', '', labelText);
    label.htmlFor = id;
    var input = el(type === 'textarea' ? 'textarea' : 'input');
    input.id = id;
    input.name = name;
    if (type !== 'textarea') input.type = type || 'text';
    if (value != null) input.value = value;
    Object.keys(options).forEach(function (k) {
      if (k !== 'help') input.setAttribute(k, options[k]);
    });
    append(wrap, label, input);
    if (options.help) {
      var help = el('small', '', options.help); help.id = id + '-help';
      input.setAttribute('aria-describedby', help.id); append(wrap, help);
    }
    wireFieldValidation(input, labelText);
    append(form, wrap);
    return input;
  }
  function pair(label, value) {
    return append(
      el('div', 'fb-group__pair'),
      el('span', '', label),
      el('strong', '', value)
    );
  }
  function termsBlock(terms) {
    var box = el('div', 'fb-group__terms');
    append(box, el('h3', '', 'Before you contribute'));
    var items = el('ul');
    var values = (terms && terms.summary) || [];
    values.forEach(function (text) {
      append(items, el('li', '', text));
    });
    ['feeText', 'refundText', 'deadlineText'].forEach(function (k) {
      if (terms && terms[k] && values.indexOf(terms[k]) < 0)
        append(items, el('li', '', terms[k]));
    });
    append(box, items);
    return box;
  }
  function hasTerms(terms) {
    return !!(
      terms &&
      terms.version &&
      ((terms.summary && terms.summary.length) || terms.refundText)
    );
  }
  function paymentAttention(contribution) {
    return (contribution.refunds || []).some(function (refund) {
      return refund.requiresAttention;
    })
      ? el(
          'p',
          '',
          'A refund needs attention. Contact Fig & Bloom support for help. It has not been confirmed.'
        )
      : contribution.requiresAttention
        ? el(
            'p',
            '',
            'This payment needs attention. Contact Fig & Bloom support for help. Its status has not been confirmed.'
          )
        : null;
  }
  function Controller(page) {
    this.page = page;
    this.api = root.FBRemindersAPI.create(page.dataset.apiBase);
    this.params = new URLSearchParams(root.location.search);
    this.view = this.params.get('reminder_view');
    this.id = this.params.get('id');
    this.token =
      new URLSearchParams((root.location.hash || '').slice(1)).get('token') ||
      this.params.get('token') ||
      (root.history &&
        root.history.state &&
        root.history.state.fbGroupInvitationToken);
    this.mount = page.querySelector('[data-group-gift-root]');
    this.entry = page.querySelector('[data-group-gift-entry]');
    this.listMount = page.querySelector('[data-group-gifts-list]');
    this.group = null;
    this.capabilities = null;
    this.terms = null;
    this.busy = false;
    this.keys = {};
    this.selected = new Map();
    this.rail = null;
    this.quote = null;
    this.me = null;
    this.paymentTimers = [];
    this.dialog = null;
    this.loadVersion = 0;
    this.identityVersion = 0;
    var self = this;
    if (this.view === 'group-invite') {
      var referrer =
        root.document.querySelector('meta[name="referrer"]') || el('meta');
      referrer.name = 'referrer';
      referrer.content = 'no-referrer';
      if (!referrer.parentNode) root.document.head.appendChild(referrer);
      if (this.params.get('token') && this.token) {
        var cleaned = new URL(root.location.href);
        cleaned.searchParams.delete('token');
        cleaned.hash = 'token=' + encodeURIComponent(this.token);
        root.history.replaceState(null, '', cleaned.href);
      }
    }
    root.document.addEventListener('fb-reminders:verified', async function (event) {
      if (
        self.view === 'group' ||
        self.view === 'group-invite' ||
        self.view === 'person' ||
        !self.view ||
        self.view === 'list' ||
        self.resumeAfterSignIn
      ) {
        // Invalidate private action responses as soon as authentication changes.
        self.identityVersion++;
        var resume = self.resumeAfterSignIn;
        self.resumeAfterSignIn = false;
        // Conceal old account details while the new identity is being checked.
        // Keep a same-account form in memory until that check confirms access.
        if (!resume && self.dialog && self.dialog.open)
          resume = {
            memberId: self.me && self.me.member && self.me.member.id,
            dialogOpen: true,
            view: self.view,
            id: self.id,
            occasionId: self.occasion && self.occasion.id,
            role: self.group && self.group.role,
            state: self.group && self.group.state,
            permissions: self.group && JSON.stringify(self.group.permissions)
          };
        self.closeDrawer(true, true);
        [self.mount, self.entry, self.listMount].forEach(function (mount) {
          if (mount) mount.hidden = true;
        });
        var sheet = root.document.getElementById('fb-reminders-sheet');
        var source = event.detail && event.detail.source;
        // Ordinary reminder verification owns its saved/preferences/duplicate
        // result. Refresh private group state without dismissing that result.
        if (
          sheet && root.FBReminders &&
          (source === 'group_sign_in' || source === 'group_invitation')
        ) root.FBReminders.init(sheet).close();
        self.api.clearMe();
        var loading = self.load();
        var version = self.loadVersion;
        await loading;
        if (version !== self.loadVersion) return;
        var sameContext = await self.canResumePrivateContext(resume);
        if (version !== self.loadVersion) return;
        if (sameContext && self.resumePlanning) self.resumePlanning();
        else if (!sameContext && self.planningBlocked) {
          self.planningBlocked = false; self.resumePlanning = null;
          if (self.productDetails) self.productDetails.dispose();
          self.productDetails = null;
          if (self.planModel) self.planModel.dispose();
          self.planModel = null;
          if (self.group) self.renderGroup();
        }
        if (sameContext && self.dialog && !self.dialog.open && resume.dialogOpen !== false) {
          self.dialog
            .querySelectorAll('[data-group-sign-in]')
            .forEach(function (entry) {
              entry.remove();
            });
          if (self.resumeDelivery) self.resumeDelivery();
          self.dialog.showModal();
          root.document.body.style.overflow = 'hidden';
          self.notify('', true);
          self.notify(
            'You’re signed in again. Your details are still here. Review them before continuing.'
          );
        } else if (!sameContext && resume && self.dialog) {
          self.discardSetup();
          // A different account or changed role must not inherit private organiser inputs.
          self.dialog.querySelector('.fb-group__dialog-body').textContent = '';
          var footer = self.dialog.querySelector('.fb-group__dialog-footer');
          if (footer) footer.remove();
          self.selected.clear();
          self.savedSelection = null;
          self.quoteSnapshot = null; self.deliveryDraft = null; self.reviewView = null; self.resumeDelivery = null;
          self.quote = null;
          if (
            self.view === 'group' &&
            self.loadedGroupVersion === self.loadVersion
          )
            self.renderGroup();
        }
      }
    });
    root.document.addEventListener('fb-reminders:closed', function () { self.resumeAfterReminderCapture(); });
    root.addEventListener('resize', function () { self.updateWorkspaceSummaryVisibility(); });
    if (root.visualViewport) root.visualViewport.addEventListener('resize', function () { self.updateWorkspaceSummaryVisibility(); });
    root.addEventListener('beforeunload', function (event) { self.guardSetupUnload(event); });
    root.addEventListener('popstate', function (event) {
      self.restoreGroupRoute(event.state);
    });
    root.addEventListener('pageshow', function (event) {
      if (event.persisted) self.load();
    });
  }
  Controller.prototype.canResumePrivateContext = async function (resume) {
    if (!resume || !this.me || !this.me.signedIn || !this.me.member || this.me.member.id !== resume.memberId || this.view !== resume.view || this.id !== resume.id) return false;
    if (this.reviewView && (!this.group || !this.group.plan || this.group.plan.version !== this.reviewView.planVersion)) return false;
    if (resume.role) return this.loadedGroupVersion === this.loadVersion && this.group && this.group.role === resume.role && this.group.state === resume.state && JSON.stringify(this.group.permissions) === resume.permissions;
    // Preserve dashboard resume from the current main entry while refreshing ownership.
    var setupId = this.setupPersonId && this.resumeSetup ? this.setupPersonId
      : (!this.view || this.view === 'list') && this.occasion && this.occasion.id === resume.occasionId ? resume.occasionId : null;
    if (setupId) {
      var identity = this.identityVersion;
      try {
        var response = await this.api.getOccasions();
        return identity === this.identityVersion && (response.occasions || []).some(function (o) { return o.id === setupId && o.next && o.next.date && !['PAUSED', 'ARCHIVED'].includes(o.status); }, this);
      } catch (_) { return false; }
    }
    return this.view === 'person' && this.occasion && this.occasion.id === this.id;
  };
  Controller.prototype.request = async function (path, body, method) {
    var identityVersion = this.identityVersion;
    try {
      var result = await this.api.request(
        path,
        body == null ? undefined : { method: method || 'POST', body: body }
      );
      if (identityVersion !== this.identityVersion)
        throw { code: 'STALE_SESSION' };
      return result;
    } catch (error) {
      if (identityVersion !== this.identityVersion)
        throw { code: 'STALE_SESSION' };
      throw error;
    }
  };
  Controller.prototype.clearPrivateState = function () {
    this.identityVersion++;
    this.group = null;
    this.routeHydrated = false;
    this.invitation = null;
    this.occasion = null;
    this.loadedGroupVersion = null;
    this.selected.clear();
    this.savedSelection = null;
    this.previousChoicesGeneration = (this.previousChoicesGeneration || 0) + 1;
    this.quoteSnapshot = null; this.deliveryDraft = null; this.reviewView = null; this.resumeDelivery = null;
    this.quote = null;
    this.quoteRevision = (this.quoteRevision || 0) + 1;
    this.rail = null;
    if (this.catalogue) this.catalogue.dispose();
    this.catalogue = null;
    this.catalogueView = null;
    if (this.setupCatalogue) this.setupCatalogue.dispose();
    this.setupCatalogue = null;
    this.setupCatalogueView = null;
    this.setupIdea = null;
    this.setupSave = null;
    this.setupContext = null;
    this.resumeSetup = null;
    this.setupPersonId = null;
    this.setupDirty = null;
    this.reminderReturn = null;
    this.drawerOrigin = null;
    this.planningWrite = null;
    this.planningBlocked = false; this.resumePlanning = null; this.resumeAfterSignIn = false;
    this.groupSection = null;
    this.workspaceFocused = false;
    if (this.productDetails) this.productDetails.dispose();
    this.productDetails = null;
    if (this.planModel) this.planModel.dispose();
    this.planModel = null;
    this.archivedIdeas = null;
    this.archiveExpanded = false;
    this.archiveLoading = false;
    this.archiveError = null;
    this.archiveGeneration = (this.archiveGeneration || 0) + 1;
    this.keys = {};
    this.closeDrawer();
    if (this.dialog) {
      this.dialog.querySelector('.fb-group__dialog-body').textContent = '';
      var footer = this.dialog.querySelector('.fb-group__dialog-footer');
      if (footer) footer.remove();
    }
    [this.mount, this.entry, this.listMount].forEach(function (mount) {
      if (mount) {
        mount.textContent = '';
        mount.hidden = true;
      }
    });
  };
  Controller.prototype.setIdentity = function (me) {
    var previous =
      this.me && this.me.signedIn && this.me.member && this.me.member.id;
    var next = me && me.signedIn && me.member && me.member.id;
    if (this.me && previous !== next) this.clearPrivateState();
    this.me = me;
  };
  Controller.prototype.endpoint = function (tail) {
    return '/group-gifts/' + encodeURIComponent(this.id) + (tail || '');
  };
  Controller.prototype.key = function (scope, body) {
    var fingerprint = JSON.stringify(body || {});
    if (!this.keys[scope] || this.keys[scope].fingerprint !== fingerprint)
      this.keys[scope] = { fingerprint: fingerprint, key: uniqueKey() };
    return this.keys[scope].key;
  };
  Controller.prototype.notify = function (text, isError) {
    var target =
      this.dialog && this.dialog.open
        ? this.dialog.querySelector(
            isError ? '[data-group-error]' : '[data-group-status]'
          )
        : this.mount.querySelector(
            isError ? '[data-group-error]' : '[data-group-status]'
          );
    if (target) target.textContent = text || '';
  };
  Controller.prototype.error = function (error) {
    if (error && error.code === 'STALE_SESSION') return;
    this.notify(
      (error && error.message) ||
        'We couldn’t finish that. Your details are still here. Try again.',
      true
    );
    if (
      error &&
      error.field === 'receiptEmail' &&
      this.dialog &&
      this.dialog.open
    )
      this.receiptEmailPanel(
        this.dialog.querySelector('.fb-group__dialog-body')
      );
    if (error && error.code === 'UNAUTHENTICATED') {
      if (this.reviewView) this.reviewView.hidePrivate();
      this.addSignIn(
        this.dialog && this.dialog.open
          ? this.dialog.querySelector('[data-group-error]')
          : this.mount
      );
      return;
    }
    var container = this.dialog && this.dialog.open ? this.dialog : this.mount;
    var form = container && container.querySelector('form');
    if (form && !this.planningBlocked) {
      var aliases = { 'shippingAddress.zip': 'zip', 'shippingAddress.province': 'province', 'shippingAddress.city': 'city', 'shippingAddress.address1': 'address1', 'shippingAddress.phone': 'phone', targetCents: 'target', deadlineAt: 'deadline', 'occasion.type': 'occasion', 'occasion.occursOn': 'occursOn', amountCents: 'amount', text: 'comment' };
      var name = error && (aliases[error.field] || error.field);
      // Find a control by its actual name; never interpolate an API field into a selector.
      var input = name && formControls(form).find(function (control) { return control.name === name; });
      formError(form, error && error.message || 'We couldn’t finish that. Try again.', input ? [input.name] : []);
    }
  };
  Controller.prototype.perform = async function (action, control, message) {
    if (this.busy) return;
    this.busy = true;
    var formContainer = this.dialog && this.dialog.open ? this.dialog : this.mount;
    var activeForm = formContainer && formContainer.querySelector('form');
    if (activeForm) clearFormErrors(activeForm);
    this.notify('', true);
    this.notify(message || 'Saving…');
    var controls =
      this.dialog && this.dialog.open
        ? this.dialog.querySelectorAll('button[type="submit"]')
        : [];
    controls.forEach(function (b) {
      b.disabled = true;
    });
    if (control) control.disabled = true;
    try {
      await action();
    } catch (error) {
      this.error(error);
    } finally {
      this.busy = false;
      controls.forEach(function (b) {
        if (b.dataset.groupLocked !== 'true') b.disabled = false;
      });
      if (
        control &&
        control.isConnected &&
        control.dataset.groupLocked !== 'true'
      )
        control.disabled = false;
    }
  };
  Controller.prototype.addSignIn = function (container) {
    if (!container || container.querySelector('[data-group-sign-in]')) return;
    var self = this;
    var a = link('Sign in to continue', '/pages/reminders', 'fb-group__button');
    a.dataset.fbRemindersOpen = '';
    a.dataset.remindersOpenState = 'identify';
    a.dataset.groupSignIn = '';
    if (this.view === 'group-invite' && this.token)
      a.dataset.groupInvitationAuth = 'true';
    a.addEventListener('click', function () {
      if (self.planningBlocked || (self.dialog && self.dialog.open && self.dialog.contains(a))) {
        self.resumeAfterSignIn = {
          memberId: self.me && self.me.member && self.me.member.id,
          dialogOpen: Boolean(self.dialog && self.dialog.open),
          view: self.view,
          id: self.id,
          occasionId: self.occasion && self.occasion.id,
          role: self.group && self.group.role,
          state: self.group && self.group.state,
          permissions: self.group && JSON.stringify(self.group.permissions)
        };
        self.quote = null;
        self.quoteRevision = (self.quoteRevision || 0) + 1;
        var quoteOutput = self.dialog && self.dialog.querySelector(
          '[data-group-quote-output]'
        );
        if (quoteOutput) quoteOutput.textContent = '';
        // Release native-modal inertness before the existing delegated sheet opener.
        self.closeDrawer(true, true);
      }
    });
    append(container, a);
  };
  Controller.prototype.shell = function () {
    this.mount.textContent = '';
    append(
      this.mount,
      link('Back to your reminders', '/pages/reminders', 'fb-group__back')
    );
    var err = el('p', 'fb-group__error');
    err.dataset.groupError = '';
    err.setAttribute('role', 'alert');
    var status = el('p', 'fb-group__status');
    status.dataset.groupStatus = '';
    status.setAttribute('role', 'status');
    append(this.mount, err, status);
    this.mount.hidden = false;
  };
  Controller.prototype.load = async function () {
    var version = ++this.loadVersion;
    if (!this.mount) return;
    if (this.view === 'person') return this.loadEntry(version);
    if ((!this.view || this.view === 'list') && !this.params.has('r'))
      return this.loadGroups(version);
    if (this.view !== 'group' && this.view !== 'group-invite') return;
    if (!this.group) {
      this.shell();
      this.notify('Loading your group gift…');
    }
    try {
      var capabilities = await this.request('/group-gifts/capabilities');
      if (version !== this.loadVersion) return;
      this.capabilities = capabilities;
      this.terms = capabilities.terms;
      if (!this.capabilities.enabled) {
        this.clearPrivateState();
        this.shell();
        append(
          this.mount,
          el('h1', '', 'Group gifts are not available yet'),
          el(
            'p',
            '',
            'You can still shop for a thoughtful gift through your reminders.'
          )
        );
        return;
      }
      var me = await this.api.me({ force: true });
      if (version !== this.loadVersion) {
        // The shared API cached this response before returning it. Do not let
        // another surface reuse an identity from an obsolete group load.
        this.api.clearMe();
        return;
      }
      this.setIdentity(me);
      if (this.view === 'group-invite') {
        if (!this.token)
          throw new Error(
            'This invitation is incomplete. Ask the organiser for a new link.'
          );
        var invited = await this.request(
          '/group-invitations/' + encodeURIComponent(this.token)
        );
        if (version !== this.loadVersion) return;
        this.invitation = invited.invitation || invited;
        this.terms = invited.terms || this.terms;
        this.renderInvitation();
        return;
      }
      if (!this.me.signedIn) {
        this.clearPrivateState();
        this.shell();
        append(
          this.mount,
          el('h1', '', 'Sign in to your group gift'),
          el('p', '', 'Use the email or mobile number you joined with.')
        );
        this.addSignIn(this.mount);
        return;
      }
      if (!this.id) throw new Error('Choose a group gift from your reminder.');
      var result;
      try {
        result = await this.request(this.endpoint());
      } catch (accessError) {
        if (version !== this.loadVersion) return;
        this.clearPrivateState();
        if (accessError.status === 404 || accessError.code === 'NOT_FOUND') {
          var history = await this.request(this.endpoint('/contributions'));
          if (version !== this.loadVersion) return;
          if (history.contributions && history.contributions.length) {
            this.renderPaymentHistory(history);
            return;
          }
        }
        throw accessError;
      }
      if (version !== this.loadVersion) return;
      var group = result.group || result;
      var savedSelection = null, quoteSnapshot = null;
      if (group.role === 'organiser' && group.state === 'closed') {
        try {
          var saved = await this.request(this.endpoint('/quote'));
          if (version !== this.loadVersion) return;
          savedSelection = saved.selection || null; quoteSnapshot = saved;
        } catch (quoteError) {
          if (version !== this.loadVersion) return;
          // A transient quote failure may leave arranging delivery available;
          // denied access must never restore a cached private group or address.
          if (
            [401, 403, 404].includes(quoteError.status) ||
            ['UNAUTHENTICATED', 'FORBIDDEN', 'NOT_FOUND', 'STALE_SESSION'].includes(quoteError.code)
          )
            throw quoteError;
        }
      }
      if (version !== this.loadVersion) return;
      if (this.group && this.group.role !== group.role) this.clearPrivateState();
      this.group = group;
      this.loadedGroupVersion = version;
      this.terms = result.terms || group.terms || this.terms;
      this.savedSelection = savedSelection; this.quoteSnapshot = quoteSnapshot;
      this.renderGroup();
      if (!this.routeHydrated) {
        this.routeHydrated = true;
        await this.restoreGroupRoute(root.history && root.history.state);
      }
    } catch (error) {
      if (version !== this.loadVersion) return;
      this.clearPrivateState();
      this.shell();
      append(this.mount, el('h1', '', 'We couldn’t open this group gift'));
      this.error(error);
      var self = this;
      append(
        this.mount,
        button(
          'Try again',
          function () {
            self.load();
          },
          true
        )
      );
    }
  };
  Controller.prototype.loadGroups = async function (version) {
    if (version == null) version = ++this.loadVersion;
    if (!this.listMount) return;
    this.listMount.hidden = true;
    this.listMount.textContent = '';
    try {
      var capabilities = await this.request('/group-gifts/capabilities');
      if (version !== this.loadVersion) return;
      if (!capabilities.enabled) {
        this.clearPrivateState();
        return;
      }
      var me = await this.api.me({ force: true });
      if (version !== this.loadVersion) {
        // The shared API cached this response before returning it. Do not let
        // another surface reuse an identity from an obsolete group load.
        this.api.clearMe();
        return;
      }
      this.setIdentity(me);
      if (!me.signedIn) return;
      var response = await this.request('/group-gifts');
      if (version !== this.loadVersion) return;
      var groups = response.groups || [];
      this.listMount.textContent = '';
      append(this.listMount, el('h2', 'fbf-summary__heading', 'Your group gifts'));
      var self = this;
      var content = el('div', 'fb-group__list-preview'), sections = groupListSections(groups), capped = groups.length >= 100;
      append(content, el('p', 'fb-group__list-count', capped ? '100+ group gifts · showing available results' : sections.active.length + ' active'));
      sections.active.slice(0, 3).forEach(function (group) { append(content, groupListRow(group)); });
      if (!sections.active.length) append(content, el('p', 'fb-group__muted', groups.length ? 'No active group gifts' : 'Bring your people together for one thoughtful gift.'));
      if (sections.unknown.length) {
        append(content, el('p', 'fb-group__list-count', 'Gifts to check'));
        sections.unknown.slice(0, Math.max(0, 3 - sections.active.length)).forEach(function (group) { append(content, groupListRow(group)); });
      }
      if (sections.active.length > 3 || sections.unknown.length || capped) append(content, button(capped ? 'View all available gifts' : sections.active.length > 3 ? 'View all ' + sections.active.length + ' active gifts' : 'View all group gifts', function () { self.groupsDrawer(groups); }, true));
      if (sections.past.length) append(content, button('Past gifts', function () { self.groupsDrawer(groups); }, true));
      append(this.listMount, content);
      var start = button('Start a group gift', function () { self.chooseGroupOccasion(); });
      start.className = 'fb-reminders-card__primary';
      append(this.listMount, start);
      this.listMount.hidden = false;
    } catch (_) {
      if (version === this.loadVersion) this.clearPrivateState();
      /* The existing Agenda remains available when groups cannot be loaded. */
    } finally {
      // The Reminders list waits for this on desktop (assets/fb-reminders.js).
      if (version === this.loadVersion) this.listMount.removeAttribute('data-fb-card-pending');
    }
  };
  Controller.prototype.groupsDrawer = function (groups) {
    var body = this.openDrawer('Your group gifts'), sections = groupListSections(groups);
    [['active', 'Active gifts'], ['unknown', 'Gifts to check'], ['past', 'Past gifts']].forEach(function (section) {
      if (!sections[section[0]].length) return;
      var container = el('section', 'fb-group__gift-list');
      append(container, el('h3', '', section[1]));
      sections[section[0]].forEach(function (group) { append(container, groupListRow(group)); });
      append(body, container);
    });
  };
  Controller.prototype.beginReminderCapture = async function (opener) {
    var sheet = root.document.getElementById('fb-reminders-sheet');
    if (!sheet || !root.FBReminders || !this.me || !this.me.signedIn) return;
    var capture = root.FBReminders.init(sheet);
    this.reminderReturn = { memberId: this.me.member.id, savedBefore: capture.savedOccasion && capture.savedOccasion.id, identity: this.identityVersion };
    this.closeDrawer(true, true);
    await capture.open(opener);
  };
  Controller.prototype.resumeAfterReminderCapture = async function () {
    var pending = this.reminderReturn;
    if (!pending || pending.resuming) return;
    pending.resuming = true;
    var identity = this.identityVersion;
    var sheet = root.document.getElementById('fb-reminders-sheet');
    var capture = sheet && root.FBReminders && root.FBReminders.init(sheet);
    var savedId = capture && capture.savedOccasion && capture.savedOccasion.id;
    try {
      var me = await this.api.me({ force: true });
      if (this.reminderReturn !== pending) return;
      if (identity !== this.identityVersion) throw { code: 'STALE_SESSION' };
      if (!me.signedIn || !me.member || me.member.id !== pending.memberId) { this.clearPrivateState(); return; }
      if (savedId && savedId !== pending.savedBefore) {
        var response = await this.api.getOccasions();
        if (this.reminderReturn !== pending) return;
        if (identity !== this.identityVersion) throw { code: 'STALE_SESSION' };
        var occasion = (response.occasions || []).find(function (o) { return o.id === savedId && o.next && o.next.date && !['PAUSED', 'ARCHIVED'].includes(o.status); });
        if (occasion) { this.reminderReturn = null; this.occasion = occasion; this.createDrawer(); return; }
      }
      this.reminderReturn = null;
      this.chooseGroupOccasion();
    } catch (error) {
      if (this.reminderReturn !== pending) return;
      pending.resuming = false;
      var self = this, body = this.openDrawer('Return to group setup');
      append(body, el('p', 'fb-group__error', 'Your reminder may be saved. Reload your people before continuing.'), button('Try again', function () { self.resumeAfterReminderCapture(); }, true));
    }
  };
  Controller.prototype.chooseGroupOccasion = async function () {
    var self = this, identity = this.identityVersion;
    var body = this.openDrawer('Who is the gift for?'), version = this.drawerVersion;
    append(body, el('h3', '', 'Set up group · 1 of 2'));
    append(body, button('Back', function () { if (self.resumeSetup) self.resumeSetup(); else self.closeDrawer(); }, true));
    var status = el('p', 'fb-group__muted', 'Loading your reminders…'); status.setAttribute('role', 'status'); append(body, status);
    try {
      var response = await this.api.getOccasions();
      if (identity !== this.identityVersion || version !== this.drawerVersion || !this.dialog.open) return;
      var occasions = (response.occasions || []).filter(function (o) {
        return o.next && /^\d{4}-\d{2}-\d{2}$/.test(o.next.date) && !['PAUSED', 'ARCHIVED'].includes(o.status);
      });
      status.textContent = '';
      if (!occasions.length) {
        append(body, el('p', '', 'Add a person and occasion to start a group gift'));
        var add = link('Add a reminder', '/pages/reminders', 'fb-group__button');
        add.setAttribute('data-fb-reminders-open', ''); add.setAttribute('data-reminders-open-state', 'capture');
        add.addEventListener('click', function (event) {
          event.preventDefault(); if (event.stopPropagation) event.stopPropagation();
          self.beginReminderCapture(add);
        });
        append(body, add); return;
      }
      var fields = el('div');
      var search = field(fields, 'group-person-search', 'Search your people and occasions', 'search', '', { autocomplete: 'off' });
      var list = el('div', 'fb-group__picker-list');
      append(body, fields, list);
      function render() {
        list.textContent = '';
        var q = search.value.trim().toLowerCase();
        var matches = occasions.filter(function (o) { return (o.name + ' ' + (o.label || o.type || '')).toLowerCase().includes(q); });
        status.textContent = matches.length + (matches.length === 1 ? ' reminder' : ' reminders');
        matches.forEach(function (o) {
          append(list, button('Choose ' + o.name + ' · ' + (o.label || o.type || 'Occasion') + ' · ' + date(o.next.date), function () {
            if (identity !== self.identityVersion) return;
            if (self.setupPersonId && self.setupPersonId !== o.id && !self.allowSetupExit()) {
              if (self.resumeSetup) self.resumeSetup();
              return;
            }
            self.occasion = o; self.createDrawer();
          }, true));
        });
        if (!matches.length) append(list, el('p', '', 'No matching reminders. Try another name or occasion.'));
      }
      search.addEventListener('input', render); render(); search.focus();
    } catch (error) {
      if (identity !== this.identityVersion || version !== this.drawerVersion) return;
      status.textContent = error.message || 'Your reminders could not be loaded.';
      append(body, button('Try again', function () { self.chooseGroupOccasion(); }, true));
    }
  };
  Controller.prototype.loadEntry = async function (version) {
    if (version == null) version = ++this.loadVersion;
    if (!this.entry) return;
    this.entry.hidden = true;
    this.entry.textContent = '';
    var self = this;
    try {
      var capabilities = await this.request('/group-gifts/capabilities');
      if (version !== this.loadVersion) return;
      this.capabilities = capabilities;
      this.terms = capabilities.terms;
      if (!this.capabilities.enabled) {
        this.clearPrivateState();
        return;
      }
      var me = await this.api.me({ force: true });
      if (version !== this.loadVersion) {
        // The shared API cached this response before returning it. Do not let
        // another surface reuse an identity from an obsolete group load.
        this.api.clearMe();
        return;
      }
      this.setIdentity(me);
      if (!me.signedIn) return;
      var responses = await Promise.all([
        this.api.getOccasions(),
        this.request('/group-gifts?occasionId=' + encodeURIComponent(this.id))
      ]);
      if (version !== this.loadVersion) return;
      this.occasion = (responses[0].occasions || []).find(function (o) {
        return o.id === self.id;
      });
      if (!this.occasion || !this.occasion.next || !/^\d{4}-\d{2}-\d{2}$/.test(this.occasion.next.date) || ['PAUSED', 'ARCHIVED'].includes(this.occasion.status)) {
        this.clearPrivateState();
        return;
      }
      this.entry.textContent = '';
      var ownedOccasion = this.occasion, identity = this.identityVersion, groups = responses[1].groups || [];
      var matching = groups.filter(function (g) {
        return groupListInfo(g).bucket === 'active' && g.occasionId === ownedOccasion.id && g.occasion && g.occasion.type === ownedOccasion.type && g.occasion.occursOn === ownedOccasion.next.date;
      });
      var occasionLabel = (ownedOccasion.label || { BIRTHDAY: 'Birthday', CHRISTMAS: 'Christmas', ANNIVERSARY: 'Anniversary' }[ownedOccasion.type] || 'occasion').toLowerCase();
      append(this.entry, el('h2', '', 'Give together for ' + ownedOccasion.name + '’s ' + occasionLabel));
      function startGroup() {
        if (identity !== self.identityVersion || version !== self.loadVersion) return;
        self.occasion = ownedOccasion; self.createDrawer();
      }
      var actions = el('div', 'fb-group__actions');
      if (matching.length === 1) {
        append(this.entry, el('p', 'fb-group__entry-status', matching[0].name + ' · ' + groupListInfo(matching[0]).status));
        var resume = link('Continue group gift', groupUrl(matching[0].id), 'fb-group__button'); resume.setAttribute('aria-label', 'Continue group gift · ' + matching[0].name);
        append(actions, resume);
      } else if (matching.length > 1) {
        append(this.entry, el('p', '', matching.length + ' active groups for this occasion'));
        append(actions, button('Choose a group gift (' + matching.length + ')', function () { if (identity === self.identityVersion) self.groupsDrawer(matching); }));
      } else {
        append(this.entry, el('p', '', 'Pool contributions with family or friends.'));
        append(actions, button('Start a group gift', startGroup));
      }
      append(this.entry, actions);
      this.entry.hidden = false;
    } catch (_) {
      if (version === this.loadVersion) this.clearPrivateState();
      /* An unavailable optional entry must not break Release 2 shopping. */
    }
  };
  Controller.prototype.openDrawer = function (title, origin) {
    this.drawerVersion = (this.drawerVersion || 0) + 1;
    this.drawerOrigin = origin || null;
    if (!this.dialog) {
      var self = this;
      this.dialog = el('dialog', 'fb-group fb-group__dialog ph-no-capture');
      this.dialog.setAttribute('aria-labelledby', 'group-dialog-heading');
      var header = el('div', 'fb-group__dialog-header');
      var heading = el('h2');
      heading.id = 'group-dialog-heading';
      var close = el('button', 'fb-group__close', '×');
      close.type = 'button';
      close.setAttribute('aria-label', 'Close panel');
      close.addEventListener('click', function () {
        self.closeDrawer();
      });
      append(header, heading, close);
      append(this.dialog, header, el('div', 'fb-group__dialog-body'));
      this.dialog.addEventListener('cancel', function (event) {
        event.preventDefault(); self.closeDrawer();
      });
      this.dialog.addEventListener('close', function () {
        if (self.dialog.open) { self.dialog.groupKeepRouteOnClose = false; return; }
        root.document.body.style.overflow = self.previousOverflow || '';
        self.updateWorkspaceSummaryVisibility();
        if (!self.dialog.groupKeepRouteOnClose) self.clearProductRoute();
        self.dialog.groupKeepRouteOnClose = false;
        self.restoreDrawerFocus();
      });
      root.document.body.appendChild(this.dialog);
    }
    this.dialog.querySelector('h2').textContent = title;
    var previousFooter = this.dialog.querySelector('.fb-group__dialog-footer');
    if (previousFooter) previousFooter.remove();
    var body = this.dialog.querySelector('.fb-group__dialog-body');
    body.textContent = '';
    var error = el('p', 'fb-group__error');
    error.dataset.groupError = '';
    error.setAttribute('role', 'alert');
    var status = el('p', 'fb-group__status');
    status.dataset.groupStatus = '';
    status.setAttribute('role', 'status');
    append(body, error, status);
    if (!this.dialog.open) {
      this.formerFocus = root.document.activeElement;
      this.previousOverflow = root.document.body.style.overflow;
      this.dialog.showModal();
      root.document.body.style.overflow = 'hidden';
    }
    this.updateWorkspaceSummaryVisibility();
    return body;
  };
  Controller.prototype.restoreDrawerFocus = function () {
    if (this.formerFocus && this.formerFocus.isConnected) { this.formerFocus.focus(); return; }
    var origin = this.drawerOrigin, area = this.mount;
    if (origin && origin.kind === 'product') {
      var view = origin.setup ? this.setupCatalogueView : this.catalogueView;
      if (origin.catalogue && view) area = view.grid;
      if (area) {
        var launcher = Array.from(area.querySelectorAll('[data-group-product-details]')).find(function (control) { return control.dataset.groupProductDetails === origin.handle; });
        if (launcher) { launcher.focus(); return; }
      }
    }
    var heading = area && area.querySelector('h2');
    if (!heading && this.mount) heading = this.mount.querySelector('h2');
    if (heading) { heading.tabIndex = -1; heading.focus(); }
  };
  Controller.prototype.guardSetupUnload = function (event) {
    if (this.setupDirty && this.setupDirty() && !(this.setupSave && this.setupSave.group)) {
      event.preventDefault(); event.returnValue = '';
    }
  };
  Controller.prototype.discardSetup = function () {
    if (this.setupCatalogue) this.setupCatalogue.dispose();
    this.setupCatalogue = null; this.setupCatalogueView = null;
    this.setupIdea = null; this.setupSave = null; this.setupContext = null;
    this.resumeSetup = null; this.setupPersonId = null; this.setupDirty = null;
  };
  Controller.prototype.allowSetupExit = function () {
    if (!this.setupDirty || !this.setupDirty() || (this.setupSave && this.setupSave.group)) return true;
    if (this.busy) { this.notify('Your group is being saved. Wait for the result before leaving.'); return false; }
    return typeof root.confirm === 'function' && root.confirm('Discard your unsaved group setup and gift idea?');
  };
  Controller.prototype.closeDrawer = function (keepRoute, preserveSetup) {
    if (this.dialog && this.dialog.open) {
      if (!preserveSetup && !this.allowSetupExit()) return false;
      if (!preserveSetup) this.discardSetup();
      // Clear the URL before close() queues its native close event. A reload
      // started after the panel disappears must keep this history entry.
      if (!keepRoute) this.clearProductRoute();
      this.dialog.groupKeepRouteOnClose = true;
      this.dialog.close();
    }
  };
  Controller.prototype.saveSetup = async function (payload, idea) {
    var identity = this.identityVersion;
    if (!this.setupSave) {
      var createBody = Object.assign({}, payload);
      createBody.idempotencyKey = this.key('create', createBody);
      this.setupSave = { createBody: createBody, group: null };
    }
    var saved = this.setupSave;
    if (!saved.group) {
      if (Object.keys(saved.createBody).filter(function (name) { return name !== 'idempotencyKey'; }).concat(Object.keys(payload)).some(function (name) { return JSON.stringify(payload[name]) !== JSON.stringify(saved.createBody[name]); }))
        throw { code: 'SETUP_PENDING', message: 'Your previous save is still being checked. Retry with the original details before changing them.' };
      var created;
      try { created = await this.request('/group-gifts', saved.createBody); }
      catch (error) {
        if (identity === this.identityVersion && error.code === 'INVALID_INPUT') this.setupSave = null;
        throw error;
      }
      if (identity !== this.identityVersion) throw { code: 'STALE_SESSION' };
      saved.group = created.group || created;
    }
    if (!idea) return { group: saved.group };
    var addition = { productHandle: idea.productHandle, variantId: idea.variantId };
    addition.idempotencyKey = this.key('setup-suggestion:' + saved.group.id, addition);
    var result = await this.request('/group-gifts/' + encodeURIComponent(saved.group.id) + '/suggestions', addition);
    if (identity !== this.identityVersion) throw { code: 'STALE_SESSION' };
    saved.group = result.group;
    if (result.change && result.change.currentState === 'archived') throw new Error('Your group is saved. This idea has since been removed. Find another gift.');
    return result;
  };
  Controller.prototype.createDrawer = function () {
    var self = this;
    var o = this.occasion;
    var personId = o.id || o.friendId;
    if (this.setupPersonId === personId && this.resumeSetup) return this.resumeSetup();
    if (this.setupCatalogue) this.setupCatalogue.dispose();
    this.setupCatalogue = null; this.setupCatalogueView = null; this.setupIdea = null; this.setupSave = null;
    this.setupPersonId = personId;
    var body = this.openDrawer('Plan a group gift');
    append(
      body,
      el(
        'p',
        '',
        'You’ll organise the gift for ' +
          o.name +
          '. Your group stays private until you open it and share an invitation.'
      )
    );
    var form = el('form');
    append(body, form);
    var step = 1, stepHeading = el('h3', '', 'Set up group · 1 of 2');
    var personFields = el('fieldset'), planFields = el('fieldset');
    append(personFields, el('legend', '', 'Who is the gift for?'), el('p', '', o.name));
    append(personFields, button('Change person', function () { self.chooseGroupOccasion(); }, true));
    append(planFields, el('legend', '', 'Plan the group'));
    append(form, stepHeading, personFields, planFields);
    field(
      planFields,
      'organiserName',
      'Your name in this group',
      'text',
      (this.me && this.me.member && this.me.member.firstName) || '',
      {
        required: '',
        maxlength: '80',
        autocomplete: 'given-name',
        help: 'Shown on the invitation and beside your suggestions.'
      }
    );
    field(planFields, 'name', 'Group name', 'text', o.name + '’s gift', {
      required: '',
      maxlength: '100',
      autocomplete: 'off'
    });
    var occasionWrap = el('div', 'fb-group__field');
    var label = el('label', '', 'Occasion');
    label.htmlFor = 'group-occasion';
    var select = el('select');
    select.id = 'group-occasion';
    select.name = 'occasion';
    append(
      select,
      new Option(
        o.type === 'BIRTHDAY'
          ? 'Birthday'
          : o.type === 'ANNIVERSARY'
            ? 'Anniversary'
            : 'This reminder',
        o.type
      ),
      new Option('Leaving gift · one-off', 'LEAVING')
    );
    append(occasionWrap, label, select);
    append(personFields, occasionWrap);
    var occurs = field(
      personFields,
      'occursOn',
      'Occasion date',
      'date',
      (o.next && o.next.date) || '',
      {
        required: '',
        help: 'This is the date for this gift. A leaving gift does not create a yearly reminder.'
      }
    );
    field(planFields, 'target', 'Collection target ($ AUD)', 'text', '', {
      required: '',
      inputmode: 'decimal',
      autocomplete: 'off',
      help: 'An amount to aim for. Allow for gifts and delivery. You can change it before opening the group.'
    });
    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'your local timezone';
    var deadlineInput = field(planFields, 'deadline', 'Contribute by · ' + timezone, 'datetime-local', '', {
      required: '',
      help: 'Choose a time before the occasion day. You’ll have up to seven days after contributions close to order, and must order before the occasion day.'
    });
    var deadlineReview = el('p', 'fb-group__muted');
    append(planFields, deadlineReview, el('p', 'fb-group__muted', 'Saved when you choose Save group. Private until you open the group and share an invitation.'));
    deadlineInput.addEventListener('input', function () {
      var instant = new Date(deadlineInput.value);
      deadlineReview.textContent = Number.isFinite(instant.getTime()) ? 'Contribute by ' + date(instant.toISOString(), true) + ' · Melbourne time.' : '';
    });
    var submit = button('Save group');
    submit.type = 'submit';
    var continueButton = button('Continue'); continueButton.type = 'submit';
    var back = button('Back', function () { if (step === 2) showStep(1); else self.closeDrawer(); }, true);
    append(form, append(el('div', 'fb-group__actions'), back, continueButton, submit));
    function showStep(next) {
      step = next;
      stepHeading.textContent = 'Set up group · ' + step + ' of 2';
      personFields.hidden = step !== 1; personFields.disabled = step !== 1;
      planFields.hidden = step !== 2; planFields.disabled = step !== 2;
      continueButton.hidden = step !== 1; submit.hidden = step !== 2;
      stepHeading.tabIndex = -1; stepHeading.focus();
    }
    showStep(1);
    select.addEventListener('change', function () {
      occurs.readOnly = select.value !== 'LEAVING' && !!(o.next && o.next.date);
      if (select.value !== 'LEAVING')
        occurs.value = (o.next && o.next.date) || '';
    });
    occurs.readOnly = !!(o.next && o.next.date);
    var ideaSummary = el('p', 'fb-group__context');
    planFields.insertBefore(ideaSummary, form.elements.target.parentNode);
    var partial = el('p', 'fb-group__error'); partial.setAttribute('role', 'alert'); append(form, partial);
    function updateIdea() {
      var idea = self.setupIdea;
      ideaSummary.hidden = !idea;
      ideaSummary.textContent = idea ? idea.title + ' · ' + idea.variantLabel + ' · ' + money(idea.priceCents) + '. Delivery is checked later.' : '';
      submit.textContent = idea ? 'Save group & add idea' : 'Save group';
    }
    this.resumeSetup = function () {
      body = self.openDrawer('Plan a group gift');
      append(body, el('p', '', 'Private until you open the group and share an invitation.'), form);
      updateIdea();
    };
    this.setupContext = {
      occasionId: o.id && o.type !== 'OTHER' ? o.id : null, friendId: o.friendId, name: o.name,
      getTargetCents: function () { var amount = cents(form.elements.target.value); return amount !== null && amount >= 100 && amount <= 1000000 ? amount : null; },
      onUse: function () { self.resumeSetup(); }, onBack: function () { self.setupBrowseDrawer(); }
    };
    function setupValues() {
      return ['organiserName', 'name', 'occasion', 'occursOn', 'target', 'deadline'].map(function (name) { return String(form.elements[name].value); }).join('\u0000');
    }
    var initialValues = setupValues();
    this.setupDirty = function () { return Boolean(self.setupIdea) || setupValues() !== initialValues; };
    var explore = button('Explore gifts and prices', function () { self.setupBrowseDrawer(); }, true);
    append(planFields, explore);
    updateIdea();
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      if (step === 1) { showStep(2); return; }
      var amount = cents(form.elements.target.value);
      var deadline = new Date(form.elements.deadline.value);
      if (amount === null || amount < 100 || amount > 1000000 || !Number.isFinite(deadline.getTime())) {
        formError(form, 'Enter a target from $1 to $10,000 and a valid contribution deadline.',
          (amount === null || amount < 100 || amount > 1000000 ? ['target'] : []).concat(!Number.isFinite(deadline.getTime()) ? ['deadline'] : []));
        return;
      }
      var payload = {
        occasionId: select.value === 'LEAVING' ? null : o.id,
        friendId: o.friendId,
        organiserName: form.elements.organiserName.value.trim(),
        name: form.elements.name.value.trim(),
        targetCents: amount,
        deadlineAt: deadline.toISOString(),
        occasion: {
          type: select.value,
          occursOn: occurs.value,
          recurrence: select.value === 'LEAVING' ? 'once' : 'annual'
        }
      };
      return self.perform(
        async function () {
          function lockSetup(locked) {
            back.disabled = locked; explore.disabled = locked;
            ['input', 'select'].forEach(function (tag) {
              Array.from(form.querySelectorAll(tag)).forEach(function (input) { input.disabled = locked; });
            });
          }
          lockSetup(true);
          try {
            var response = await self.saveSetup(payload, self.setupIdea);
            root.location.assign(groupUrl(response.group.id));
          } catch (error) {
            if (error.code === 'STALE_SESSION') throw error;
            if (!self.setupSave) throw error;
            if (!self.setupSave.group) {
              partial.textContent = 'We couldn’t confirm whether your group was saved. Retry the same details to check; your inputs are kept unchanged.';
              submit.textContent = 'Retry saving group';
              throw error;
            }
            partial.textContent = 'Your group is saved. This idea wasn’t added. Try adding again, or find another gift.';
            submit.textContent = 'Try adding again';
            back.disabled = true; explore.disabled = true;
            Array.from(form.querySelectorAll('input, select')).forEach(function (input) { input.disabled = true; });
            append(form, button('Find another gift', function () { root.location.assign(groupUrl(self.setupSave.group.id) + '&group_section=gifts'); }, true));
          } finally {
            if (!self.setupSave) { lockSetup(false); partial.textContent = ''; updateIdea(); }
          }
        },
        submit,
        'Creating your group…'
      );
    });
  };
  Controller.prototype.setupBrowseDrawer = function () {
    var self = this, body = this.openDrawer('Explore gifts and prices');
    append(body, button('Back to setup', function () { self.resumeSetup(); }, true),
      el('p', 'fb-group__muted', 'Saved when you choose Save group. Browsing does not create a group or change your personal shopping budget.'));
    this.renderShop(body, this.setupContext);
  };
  Controller.prototype.renderInvitation = function () {
    var self = this;
    var invite = this.invitation;
    this.shell();
    var context = el('header', 'fb-group__context');
    append(
      context,
      el(
        'p',
        'fb-group__eyebrow',
        invite.isOrganiserPreview
          ? 'Invitation preview · nothing has been sent'
          : 'You’re invited to give together'
      ),
      el('h1', '', invite.name),
      el(
        'p',
        '',
        invite.organiserName +
          ' is organising a gift for ' +
          invite.recipientName +
          '.'
      )
    );
    append(
      context,
      el(
        'p',
        '',
        date(invite.occasion.occursOn) +
          (invite.occasion.recurrence === 'once' ? ' · One-off occasion' : '')
      ),
      el('p', '', 'Contribute by ' + date(invite.deadlineAt, true)),
      pair('Group target', money(invite.targetCents))
    );
    append(
      this.mount,
      context,
      el(
        'div',
        'fb-group__notice',
        'Keep the surprise. This invitation is for the people giving the gift, not the recipient.'
      )
    );
    if (invite.purchaseDeadlineAt)
      append(
        this.mount,
        el('p', '', 'Order by ' + date(invite.purchaseDeadlineAt, true))
      );
    if (hasTerms(this.terms)) append(this.mount, termsBlock(this.terms));
    var actions = el('div', 'fb-group__actions');
    if (!this.me.signedIn || invite.needsSignIn) this.addSignIn(actions);
    else if (invite.groupId && !invite.canJoin)
      append(
        actions,
        link(
          invite.isOrganiserPreview
            ? 'Return to your group'
            : 'Open your group',
          groupUrl(invite.groupId),
          'fb-group__button'
        )
      );
    else if (invite.canJoin) {
      var joinForm = el('form');
      var displayName = field(
        joinForm,
        'displayName',
        'Your name in this group',
        'text',
        (this.me.member && this.me.member.firstName) || '',
        {
          required: '',
          maxlength: '80',
          autocomplete: 'given-name',
          help: 'Shown beside your suggestions and to the organiser with your contribution.'
        }
      );
      var join = button('Join this group gift');
      join.type = 'submit';
      joinForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!joinForm.reportValidity()) return;
        var payload = { name: displayName.value.trim() };
        payload.idempotencyKey = self.key('join', {
          token: self.token,
          name: payload.name
        });
        self.perform(
          async function () {
            var result = await self.request(
              '/group-invitations/' + encodeURIComponent(self.token) + '/join',
              payload
            );
            root.location.assign(groupUrl((result.group || result).id));
          },
          join,
          'Joining the group…'
        );
      });
      append(joinForm, append(el('div', 'fb-group__actions'), join));
      append(actions, joinForm);
    }
    append(
      this.mount,
      actions,
      el(
        'p',
        'fb-group__muted',
        'Joining does not make a payment or sign you up for reminders. Only the organiser can place the order.'
      )
    );
    this.focusHeading();
  };
  Controller.prototype.focusHeading = function () {
    var heading = this.mount.querySelector('h1');
    if (heading) {
      heading.tabIndex = -1;
      heading.focus({ preventScroll: true });
    }
  };
  Controller.prototype.navigateSection = function (section, restoring) {
    if (!['overview', 'gifts', 'shortlist', 'contributions'].includes(section) || !this.group) return;
    this.routeVersion = (this.routeVersion || 0) + 1;
    if (!restoring) this.restoringRoute = false;
    this.closeDrawer(true);
    if (!restoring && root.history) {
      var publicState = this.catalogue ? this.catalogue.snapshot() : null;
      if (root.history.replaceState) root.history.replaceState({ fbGroupCatalogue: publicState, fbGroupScrollY: root.scrollY || 0 }, '', root.location.href);
      root.history.pushState({ fbGroupCatalogue: publicState, fbGroupScrollY: 0 }, '', groupUrl(this.group.id) + '&group_section=' + section);
    }
    this.groupSection = section;
    this.renderGroup();
    var main = this.mount.querySelector('.fb-group__main'), heading = main && main.querySelector('h2');
    if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
  };
  Controller.prototype.writeProductRoute = function (product, replacing) {
    if (!this.group || !this.id || !root.history) return;
    var variant = String(product.variantId || '').split('/').pop();
    var url = new URL(groupUrl(this.id), root.location.origin);
    url.searchParams.set('group_section', this.groupSection || 'gifts');
    url.searchParams.set('gift_handle', product.handle);
    if (/^\d+$/.test(variant)) url.searchParams.set('gift_variant', variant);
    var state = { fbGroupCatalogue: this.catalogue ? this.catalogue.snapshot() : null, fbGroupScrollY: root.scrollY || 0 };
    if (replacing) root.history.replaceState(state, '', url.href);
    else {
      if (root.history.replaceState) root.history.replaceState(state, '', root.location.href);
      root.history.pushState(state, '', url.href);
    }
  };
  Controller.prototype.clearProductRoute = function () {
    if (!root.history || !root.location.href) return;
    var url = new URL(root.location.href);
    if (url.searchParams.get('id') !== this.id || (!url.searchParams.has('gift_handle') && !url.searchParams.has('group_step'))) return;
    url.searchParams.delete('gift_handle'); url.searchParams.delete('gift_variant'); url.searchParams.delete('group_step');
    root.history.replaceState(root.history.state, '', url.href);
  };
  // Milestones navigate existing work; only explicit panel submissions change state.
  Controller.prototype.navigateStage = function (stage) {
    var group = this.group;
    if (!group || this.planningBlocked || !root.FBGroupGiftsJourney) return;
    var milestone = root.FBGroupGiftsJourney.view(group).stages.find(function (item) { return item.id === stage; });
    if (!milestone || !milestone.enabled) return;
    if (stage === 'setup') {
      var body = this.openDrawer('Group setup'), self = this;
      append(body, el('p', '', 'For ' + group.recipientName + ' · ' + date(group.occasion.occursOn)),
        pair('Group name', group.name), pair('Collection target', money((group.budget || {}).targetCents || group.targetCents || 0)),
        pair('Contribute by', date(group.deadlineAt, true)));
      if (group.purchaseDeadlineAt) append(body, pair('Order by', date(group.purchaseDeadlineAt, true)));
      if (group.role === 'organiser' && group.state === 'draft' && (group.permissions || {}).canManage)
        append(body, button('Edit group settings', function () { self.editGroupDrawer(); }, true));
      else append(body, el('p', 'fb-group__muted', 'These settings are fixed once contributions open.'));
      return;
    }
    if (stage === 'confirm_gifts') {
      if (this.canOpenJourneyStep('confirm')) return this.confirmGiftsDrawer();
      return this.navigateSection('shortlist');
    }
    if (stage === 'delivery_review') {
      if (this.canOpenJourneyStep('review')) return this.quoteDrawer('review');
      if (this.canOpenJourneyStep('delivery')) return this.quoteDrawer('delivery');
    }
    return this.navigateSection('overview');
  };
  Controller.prototype.canOpenJourneyStep = function (step) {
    var group = this.group, action = { confirm: 'confirm_gifts', delivery: 'enter_delivery', review: 'review_order' }[step];
    if (!action || !group || group.role !== 'organiser' || !group.journey) return false;
    if (!root.FBGroupGiftsJourney || !root.FBGroupGiftsJourney.view(group).progressAvailable) return false;
    if (step === 'confirm' ? !group.permissions.canConfirmPlan : !group.permissions.canQuote) return false;
    return [group.journey.primaryAction].concat(group.journey.secondaryActions || []).some(function (candidate) {
      return candidate && candidate.id === action && candidate.enabled === true;
    });
  };
  Controller.prototype.writeJourneyStepRoute = function (step) {
    if (!this.canOpenJourneyStep(step) || !root.history || !root.location.href) return;
    var current = new URL(root.location.href);
    if (current.searchParams.get('reminder_view') !== 'group' || current.searchParams.get('id') !== this.id) return;
    if (current.searchParams.get('group_step') === step) return;
    var url = new URL(groupUrl(this.id), root.location.origin);
    url.searchParams.set('group_section', this.groupSection || 'overview');
    url.searchParams.set('group_step', step);
    var state = { fbGroupCatalogue: this.catalogue ? this.catalogue.snapshot() : null, fbGroupScrollY: root.scrollY || 0 };
    root.history.replaceState(state, '', current.href);
    root.history.pushState(state, '', url.href);
  };
  Controller.prototype.restoreGroupRoute = async function (saved) {
    if (!this.group || !root.location.href) return;
    var params = new URL(root.location.href).searchParams;
    if (params.get('reminder_view') !== 'group' || params.get('id') !== this.group.id) {
      if (root.location.reload) { this.clearPrivateState(); root.location.reload(); }
      return;
    }
    var identity = this.identityVersion, groupId = this.group.id;
    this.restoringRoute = true;
    try {
      this.params = params;
      var section = params.get('group_section');
      this.navigateSection(['overview', 'gifts', 'shortlist', 'contributions'].includes(section) ? section : 'overview', true);
      var version = this.routeVersion;
      saved = saved || {};
      if (this.groupSection === 'gifts' && this.catalogue && saved.fbGroupCatalogue) {
        var current = this.catalogue.snapshot();
        if (JSON.stringify(current) !== JSON.stringify(saved.fbGroupCatalogue)) {
          await this.catalogue.restore(saved.fbGroupCatalogue);
          if (identity !== this.identityVersion || !this.group || this.group.id !== groupId || version !== this.routeVersion) return;
          this.renderGroup();
        }
      }
      if (identity !== this.identityVersion || version !== this.routeVersion) return;
      if (root.scrollTo) root.scrollTo(0, Number.isFinite(saved.fbGroupScrollY) && saved.fbGroupScrollY >= 0 ? saved.fbGroupScrollY : 0);
      var step = params.get('group_step');
      if (step) {
        if (this.canOpenJourneyStep(step)) {
          if (step === 'confirm') this.confirmGiftsDrawer(true);
          else this.quoteDrawer(step, true);
        } else if (step === 'review' && this.canOpenJourneyStep('delivery')) {
          var replacement = new URL(root.location.href); replacement.searchParams.set('group_step', 'delivery');
          if (root.history) root.history.replaceState({ fbGroupCatalogue: this.catalogue ? this.catalogue.snapshot() : null, fbGroupScrollY: root.scrollY || 0 }, '', replacement.href);
          this.quoteDrawer('delivery', true);
          this.notify('The previous review is no longer current. Check delivery and total again.');
        } else {
          var recovery = this.group.role === 'organiser' && (step === 'confirm' || (this.group.plan && this.group.plan.items.length)) ? 'shortlist' : 'overview';
          this.navigateSection(recovery, true);
          this.notify('This step is unavailable. Review the current group and its next action.');
        }
        return;
      }
      var handle = params.get('gift_handle'), variant = params.get('gift_variant');
      if (this.group.permissions.canBrowseGifts && handle && /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) && (!variant || /^\d+$/.test(variant)))
        this.productDrawer({ handle: handle, variantId: variant }, null, null, true);
    } finally {
      if (version === this.routeVersion) this.restoringRoute = false;
    }
  };
  Controller.prototype.dispatchJourneyAction = function (id, control) {
    var self = this, g = this.group, journey = g && g.journey;
    if (!g || !root.FBGroupGiftsJourney || !root.FBGroupGiftsJourney.view(g).progressAvailable) return;
    var permitted = journey && [journey.primaryAction].concat(journey.secondaryActions || []).some(function (action) { return action && action.id === id && action.enabled === true; });
    if (!permitted) return;
    if (id === 'browse_gifts') return this.navigateSection('gifts');
    if (id === 'review_shortlist') return this.navigateSection('shortlist');
    if (id === 'confirm_gifts') return this.confirmGiftsDrawer();
    if (id === 'view_contributions') return this.navigateSection('contributions');
    if (id === 'open_group') return this.openGroupDrawer();
    if (id === 'close_contributions') return this.closeGroupDrawer();
    if (id === 'invite_people') return this.inviteDrawer();
    if (id === 'contribute' && g.permissions.canContribute) return this.contributionDrawer();
    if (id === 'top_up' && g.permissions.canTopUp) return this.quoteDrawer('review');
    if (id === 'enter_delivery' || id === 'review_order') return this.quoteDrawer(id === 'enter_delivery' ? 'delivery' : 'review');
    if (id === 'verify_receipt_email') return this.receiptEmailPanel(this.openDrawer('Verify your receipt email'));
    if (id === 'view_order') return this.navigateSection('overview');
    if (id === 'edit_group') return this.editGroupDrawer();
    if (id === 'contact_support') {
      var support = this.openDrawer('Your order needs support review');
      append(support, el('p', '', 'The existing order is being reviewed. Do not start another order.'),
        link('Contact Fig & Bloom support', 'https://figandbloom.com/pages/contact', 'fb-group__button'));
      return;
    }
    if (id === 'continue_payment') {
      var payment = (g.contributions || []).find(function (c) { return (g.role === 'contributor' || c.isOwn) && c.canResume && safeCheckout(c.checkoutUrl, 'contribution'); });
      if (payment) return root.location.assign(safeCheckout(payment.checkoutUrl, 'contribution'));
      return this.navigateSection('contributions');
    }
    if (id === 'check_payment') {
      var own = (g.contributions || []).find(function (c) { return (g.role === 'contributor' || c.isOwn) && ['initiated', 'pending', 'refund_pending'].includes(c.state); });
      if (!own) return this.navigateSection('contributions');
      return this.perform(async function () { await self.request(self.endpoint('/contributions/' + encodeURIComponent(own.id))); await self.load(); self.navigateSection('contributions'); }, control, 'Checking your payment…');
    }
    if (id === 'check_order') return this.perform(async function () { if (g.role === 'organiser') await self.request(self.endpoint('/purchase')); await self.load(); }, control, 'Checking the existing order…');
    if (id === 'refresh_status') return this.perform(function () { return self.load(); }, control, 'Checking current status…');
  };
  Controller.prototype.confirmGiftsDrawer = function (restoring) {
    var self = this, group = this.group;
    if (!this.canOpenJourneyStep('confirm')) return;
    if (this.planModel && this.planModel.state.saving) {
      this.notify('Wait for your gift choices to finish saving before confirming.'); return;
    }
    var displayedVersion = group.plan.version;
    if (!restoring) this.writeJourneyStepRoute('confirm');
    var body = this.openDrawer('Confirm your chosen gifts'), identity = this.identityVersion, version = this.drawerVersion;
    append(body, el('p', '', 'Confirm these saved choices before delivery review. Delivery and the final total still need review; nothing has been ordered.'));
    group.plan.items.forEach(function (item) {
      append(body, el('p', '', item.product.title + ' · ' + item.product.variantLabel + ' · ' + money(item.product.priceCents)));
    });
    append(body, pair('Item estimate', money(group.plan.itemSubtotalCents)), el('p', 'fb-group__muted', 'Delivery is checked next. Changing your choices will require confirmation again.'));
    var error = el('p', 'fb-group__error'); error.setAttribute('role', 'alert'); append(body, error);
    var confirm = button('Confirm chosen gifts', async function () {
      if (identity !== self.identityVersion || !self.group || self.group.id !== group.id || !self.canOpenJourneyStep('confirm')) return;
      var actions = self.planActions();
      if (actions.state.saving) {
        error.textContent = 'Wait for your gift choices to finish saving before confirming.'; return;
      }
      if (self.group.plan.version !== displayedVersion) {
        confirm.disabled = true;
        error.textContent = 'These choices changed. Review the latest shortlist before confirming.';
        error.tabIndex = -1; error.focus(); return;
      }
      confirm.disabled = true;
      await actions.confirm(displayedVersion);
      if (identity !== self.identityVersion || version !== self.drawerVersion) return;
      confirm.disabled = false;
      if (actions.state.error) {
        error.textContent = actions.state.error.message;
        if (self.group.plan.version !== group.plan.version) {
          confirm.disabled = true;
          error.textContent += ' Review the latest shortlist before confirming.';
        }
        error.tabIndex = -1; error.focus();
        return;
      }
      if (self.group.plan.version !== displayedVersion || self.group.plan.confirmedVersion !== displayedVersion) {
        error.textContent = 'We couldn’t confirm these choices. Review the latest shortlist before confirming.';
        error.tabIndex = -1; error.focus(); return;
      }
      self.closeDrawer();
      self.notify('Your chosen gifts are confirmed. Review the next step before ordering.');
    });
    confirm.setAttribute('aria-label', 'Confirm chosen gifts: ' + group.plan.items.map(function (item) { return item.product.title + ' · ' + item.product.variantLabel; }).join(', '));
    append(body, append(el('div', 'fb-group__actions'), confirm, button('Review shortlist', function () { self.navigateSection('shortlist'); }, true)));
  };
  Controller.prototype.editGroupDrawer = function () {
    var self = this, group = this.group;
    if (!group || group.role !== 'organiser' || group.state !== 'draft' || !group.permissions.canManage) return;
    var body = this.openDrawer('Edit private group'), identity = this.identityVersion, version = this.drawerVersion;
    append(body, el('p', '', 'The recipient stays the same. These settings become fixed when you open contributions.'));
    var form = el('form'); append(body, form);
    field(form, 'name', 'Group name', 'text', group.name, { required: '', maxlength: '100', autocomplete: 'off' });
    field(form, 'target', 'Collection target ($ AUD)', 'text', group.targetCents / 100, { required: '', inputmode: 'decimal', help: 'An amount to aim for. Allow for gifts and delivery. $1–$10,000.' });
    var instant = new Date(group.deadlineAt);
    var localValue = new Date(instant.getTime() - instant.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'your local timezone';
    var deadline = field(form, 'deadline', 'Contribute by · ' + timezone, 'datetime-local', localValue, { required: '', help: 'Choose a time before the occasion day. You’ll have up to seven days after contributions close to order, and must order before the occasion day.' });
    var review = el('p', 'fb-group__muted', 'Contribute by ' + date(group.deadlineAt, true) + ' · Melbourne time.'); append(form, review);
    deadline.addEventListener('input', function () {
      var changed = new Date(deadline.value);
      review.textContent = Number.isFinite(changed.getTime()) ? 'Contribute by ' + date(changed.toISOString(), true) + ' · Melbourne time.' : '';
    });
    var submit = button('Save changes'); submit.type = 'submit';
    append(form, append(el('div', 'fb-group__actions'), submit, button('Keep as it is', function () { self.closeDrawer(); }, true)));
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity() || identity !== self.identityVersion || !self.group || self.group.id !== group.id || self.group.state !== 'draft' || self.group.role !== 'organiser' || !self.group.permissions.canManage) return;
      var amount = cents(form.elements.target.value), changed = new Date(deadline.value);
      if (amount === null || amount < 100 || amount > 1000000 || !Number.isFinite(changed.getTime())) {
        formError(form, 'Enter a target from $1 to $10,000 and a valid contribution deadline.',
          (amount === null || amount < 100 || amount > 1000000 ? ['target'] : []).concat(!Number.isFinite(changed.getTime()) ? ['deadline'] : [])); return;
      }
      var payload = { name: form.elements.name.value.trim(), targetCents: amount, deadlineAt: deadline.value === localValue ? group.deadlineAt : changed.toISOString() };
      return self.perform(async function () {
        var response = await self.requestPlanning('/group-gifts/' + encodeURIComponent(group.id), payload, 'PATCH');
        if (identity !== self.identityVersion || version !== self.drawerVersion) return;
        self.group = response.group; self.renderGroup(); self.closeDrawer();
        self.notify('Your private group settings are saved.');
      }, submit, 'Saving your group settings…');
    });
  };
  Controller.prototype.openGroupDrawer = function () {
    if (!this.group.permissions.canOpen) return;
    this.confirmDrawer('Open contributions?', 'The group name, target and dates will be fixed. People can contribute until ' + date(this.group.deadlineAt, true) + '. Opening does not send invitations or order a gift. You choose who receives the invitation link.', 'Open contributions', '/open');
  };
  Controller.prototype.closeGroupDrawer = function () {
    if (!this.group.permissions.canClose) return;
    var preview = this.group.journey && this.group.journey.closePreview;
    this.confirmDrawer('Close contributions?', 'New contributions will stop and this group cannot reopen. Payments already in progress still need checking. You can change the chosen gifts before ordering. Confirm the chosen gifts before delivery review.' + (preview ? ' If you close now, order by ' + date(preview.purchaseDeadlineAt, true) + '.' : ''), 'Close contributions', '/close');
  };
  Controller.prototype.updateWorkspaceSummaryVisibility = function () {
    if (!this.mount) return;
    var viewport = root.visualViewport;
    var keyboard = viewport && (viewport.scale == null || viewport.scale <= 1.01) && viewport.height > 0 && root.innerHeight - viewport.height > 150;
    var hidden = Boolean((this.dialog && this.dialog.open) || keyboard);
    this.mount.querySelectorAll('.fb-group__mobile-summary').forEach(function (bar) { bar.hidden = hidden; });
  };
  Controller.prototype.renderOrderSummary = function (container, summary) {
    var section = el('section', 'fb-group__section fb-group__order-summary');
    append(section, el('h3', '', 'Order confirmed'));
    if (!summary) {
      append(section, el('p', '', 'The order is confirmed. Item details were not recorded for this order.'));
    } else {
      summary.lines.forEach(function (line) {
        append(section, el('p', '', line.title + ' · ' + line.variantLabel + (line.quantity > 1 ? ' · ' + line.quantity + ' items' : '') + ' · ' + money(line.unitCents * line.quantity)));
      });
      append(section, pair('Delivery', money(summary.deliveryCents)), pair('Order total', money(summary.totalCents)),
        el('p', 'fb-group__muted', 'These are the items and prices accepted for this order.'));
    }
    append(container, section);
  };
  Controller.prototype.renderWorkspaceSummary = function (container) {
    var self = this, plan = this.group.plan;
    if (this.group.state === 'completed' && this.group.purchase && this.group.purchase.state === 'completed') {
      var accepted = this.group.purchase.orderSummary;
      var order = el('aside', 'fb-group__workspace-summary'); order.setAttribute('aria-label', 'Confirmed order summary');
      this.renderOrderSummary(order, accepted); append(container, order);
      var orderedBar = el('div', 'fb-group__mobile-summary');
      append(orderedBar, el('span', '', 'Order confirmed' + (accepted ? ' · ' + money(accepted.totalCents) : '')), button('View order', function () { self.chosenSummaryDrawer(); }, true));
      append(this.mount, orderedBar); this.updateWorkspaceSummaryVisibility(); return;
    }
    var summary = el('aside', 'fb-group__workspace-summary'); summary.setAttribute('aria-label', 'Chosen gift summary');
    append(summary, el('h2', '', 'Chosen gifts'), el('p', '', plan.items.length + ' chosen'), pair('Item estimate', money(plan.itemSubtotalCents)),
      el('p', 'fb-group__muted', 'Delivery not yet quoted'), pair('Confirmed available funds', money(this.group.budget.availableCents)),
      button('Review choices', function () { self.chosenSummaryDrawer(); }, true));
    append(container, summary);
    var bar = el('div', 'fb-group__mobile-summary'); bar.hidden = Boolean(this.dialog && this.dialog.open);
    append(bar, el('span', '', plan.items.length + ' chosen · ' + money(plan.itemSubtotalCents) + ' items'), button('Review choices', function () { self.chosenSummaryDrawer(); }, true));
    append(this.mount, bar);
    this.updateWorkspaceSummaryVisibility();
  };
  Controller.prototype.chosenSummaryDrawer = function () {
    var self = this;
    if (this.group.state === 'completed' && this.group.purchase && this.group.purchase.state === 'completed') {
      var orderBody = this.openDrawer('Your confirmed order');
      this.renderOrderSummary(orderBody, this.group.purchase.orderSummary);
      append(orderBody, button('View group', function () { self.navigateSection('overview'); }, true)); return;
    }
    var body = this.openDrawer('Your chosen gifts');
    this.group.plan.items.forEach(function (item) { append(body, el('p', '', item.product.title + ' · ' + item.product.variantLabel + ' · ' + money(item.product.priceCents))); });
    append(body, pair('Item estimate', money(this.group.plan.itemSubtotalCents)), el('p', 'fb-group__muted', 'Delivery is checked later. These choices are saved; nothing has been ordered.'),
      button('View shortlist', function () { self.navigateSection('shortlist'); }, true));
  };
  Controller.prototype.renderGroup = function () {
    var self = this;
    if (this.planningBlocked) {
      this.shell(); append(this.mount, el('p', '', 'Sign in with the same account to review your saved work and continue.'));
      this.addSignIn(this.mount); return;
    }
    var g = this.group;
    var p = g.permissions || {};
    var section = this.groupSection || (this.params && this.params.get('group_section')) || 'overview';
    if (!['overview', 'gifts', 'shortlist', 'contributions'].includes(section)) section = 'overview';
    this.groupSection = section;
    var journey = root.FBGroupGiftsJourney.view(g, section);
    this.shell();
    var context = el('header', 'fb-group__context fb-group__workspace-header');
    append(
      context,
      el(
        'p',
        'fb-group__eyebrow',
        g.role === 'organiser'
          ? 'You’re organising this gift'
          : 'You’re contributing · ' + g.organiserName + ' is organising'
      ),
      el('h1', '', g.name),
      el('p', '', 'For ' + g.recipientName + ' · ' + date(g.occasion.occursOn))
    );
    if (journey.progressAvailable) append(context, el('span', 'fb-group__group-status', journey.statusLabel));
    var meta = el('div', 'fb-group__meta');
    append(
      meta,
      el(
        'p',
        '',
        date(g.occasion.occursOn) +
          (g.occasion.recurrence === 'once' ? ' · One-off occasion' : '')
      ),
      el('p', '', 'Contribute by ' + date(g.deadlineAt, true))
    );
    if (g.purchaseDeadlineAt)
      append(meta, el('p', '', 'Order by ' + date(g.purchaseDeadlineAt, true)));

    append(this.mount, context, root.FBGroupGiftsJourney.render(g, { section: section, showGuidance: section !== 'gifts', progressExpanded: this.progressExpanded === true, onProgressToggle: function (expanded) { self.progressExpanded = expanded; }, onStageNavigate: function (stage) { self.navigateStage(stage); }, onNavigate: function (next) { self.navigateSection(next); }, onAction: function (id, control) { self.dispatchJourneyAction(id, control); }, onRefresh: function (control) { self.perform(async function () { await self.load(); }, control, 'Checking current status…'); } }));
    var layout = el('div', 'fb-group__layout');
    var funds = el('aside', 'fb-group__funds');
    if (section === 'overview') funds.classList.add('fb-group__funds--compact');
    funds.setAttribute('aria-label', 'Group funds');
    var budget = g.budget || {};
    append(
      funds,
      el('p', '', 'Available for the gift'),
      el('div', 'fb-group__amount', money(budget.availableCents)),
      el(
        'p',
        'fb-group__muted',
        'Confirmed funds, after holds and amounts already committed.'
      )
    );
    var detail = el('div', 'fb-group__detail');
    append(
      detail,
      pair('Target', money(budget.targetCents)),
      pair('Collected', money(budget.collectedCents))
    );
    if (budget.pledgedCents)
      append(detail, pair('Pledged', money(budget.pledgedCents)));
    if (budget.pendingCents)
      append(
        detail,
        pair('Pending · not spendable', money(budget.pendingCents))
      );
    if (budget.heldCents)
      append(detail, pair('On hold', money(budget.heldCents)));
    if (budget.reservedCents)
      append(
        detail,
        pair('Reserved for the order', money(budget.reservedCents))
      );
    if (budget.spentCents)
      append(detail, pair('Spent on the gift', money(budget.spentCents)));
    if (budget.heldForClosureCents)
      append(
        detail,
        pair('Awaiting return', money(budget.heldForClosureCents))
      );
    if (budget.shortfallCents)
      append(detail, pair('Shortfall on hold', money(budget.shortfallCents)));
    append(funds, detail, meta);
    var actions = el('div', 'fb-group__actions');
    function guidedAction(id) { return section !== 'gifts' && [journey.primary].concat(journey.secondary).some(function (action) { return action && action.id === id; }); }
    if (journey.progressAvailable && g.role === 'organiser' && (p.canShareInvitation || g.state === 'draft') && !guidedAction('invite_people'))
      append(
        actions,
        button(
          g.state === 'draft' ? 'Preview invitation' : 'Invite people',
          function () {
            self.inviteDrawer();
          }, true
        )
      );
    if (journey.progressAvailable && p.canContribute && !guidedAction('contribute'))
      append(
        actions,
        button(
          'Contribute to the gift',
          function () {
            self.contributionDrawer();
          },
          true
        )
      );
    var management = el('details', 'fb-group__manage');
    append(management, el('summary', '', 'Manage group'));
    var managementActions = el('div', 'fb-group__manage-actions');
    append(management, managementActions);
    if (journey.progressAvailable && g.role === 'organiser' && g.state === 'draft' && p.canManage) append(managementActions, button('Edit group settings', function () { self.editGroupDrawer(); }, true));
    if (journey.progressAvailable && g.role === 'organiser' && p.canManage && p.canClose && g.state === 'open' && !guidedAction('close_contributions'))
      append(
        managementActions,
        button(
          'Close contributions',
          function () {
            self.closeGroupDrawer();
          },
          true
        )
      );
    if (journey.progressAvailable && g.role === 'organiser' && (p.canPurchase || p.canTopUp) && !['enter_delivery', 'review_order', 'top_up', 'verify_receipt_email'].some(guidedAction))
      append(
        actions,
        button('Review gift and delivery', function () {
          self.quoteDrawer();
        }, true)
      );
    if (journey.progressAvailable && g.role === 'organiser' && p.canManage)
      append(
        managementActions,
        button(
          'Cancel group',
          function () {
            self.confirmDrawer(
              'Cancel this group',
              'The group will close. Eligible contributions will be queued for refund. A refund is complete only when it is confirmed by the payment provider.',
              'Cancel group and request refunds',
              '/cancel'
            );
          },
          true
        )
      );
    var refresh = button(
      'Refresh status',
      function (event) {
        self.perform(
          async function () {
            await self.load();
            self.notify('Status updated.');
          },
          event.currentTarget,
          'Checking current status…'
        );
      },
      true
    );
    refresh.classList.add('fb-group__button--quiet');
    append(funds, actions);
    var secondary = el('div', 'fb-group__secondary-actions');
    if (managementActions.children.length) append(secondary, management);
    if (journey.progressAvailable) append(secondary, refresh);
    append(funds, secondary);
    if (!g.fundingAvailable && ['draft', 'open', 'closed'].includes(g.state))
      append(
        funds,
        el(
          'p',
          'fb-group__notice',
          'Payments are not available right now. No contribution will be collected until secure payment is available.'
        )
      );
    var main = el('div', 'fb-group__main');
    if (section === 'overview') append(main, el('h2', 'fb-group__destination-heading', 'Overview'));
    layout.classList.add('fb-group__workspace-layout');
    append(layout, main);
    if (section === 'overview' || section === 'contributions') append(main, funds);
    append(this.mount, layout);
    if (section === 'overview' && g.state === 'cancelled')
      append(
        main,
        el(
          'div',
          'fb-group__notice',
          'This group is closed. Check each contribution below for its refund status. Cancellation does not mean a refund has finished.'
        )
      );
    if (section === 'overview' && g.state === 'completed')
      append(
        main,
        el(
          'div',
          'fb-group__notice',
          'The gift has been ordered. This is separate from your contribution receipt and any remaining refund.'
        )
      );
    if (section === 'overview') {
      append(main, el('p', 'fb-group__overview-purpose', g.state === 'completed' ? 'The order is confirmed. Any remaining contribution refund is separate.' : g.role === 'organiser' ? 'You choose the final gifts. Adding ideas and choosing gifts saves your plan; it does not reserve stock or place an order.' : g.organiserName + ' chooses the final gifts. You can suggest ideas and discuss them; contributing is separate from ordering.'));
      if (g.purchase) this.renderPurchase(main, g.purchase);
    }
    if (section === 'shortlist') this.renderShortlist(main, { showConfirm: !guidedAction('confirm_gifts') });
    if (section === 'contributions') this.renderGroupContributions(main);
    if (section === 'gifts' && p.canBrowseGifts) this.renderShop(main);
    if (g.role === 'organiser' && ((g.plan && g.plan.items.length) || (g.state === 'completed' && g.purchase))) this.renderWorkspaceSummary(layout);
    if (section === 'overview' && g.state === 'completed')
      append(
        main,
        append(
          el('section', 'fb-group__section'),
          el('h2', '', 'Remember the next occasion'),
          el(
            'p',
            '',
            'Your reminders are optional. Keep the dates that matter to you.'
          ),
          link(
            'View your reminders',
            '/pages/reminders',
            'fb-group__button fb-group__button--secondary'
          )
        )
      );
    this.notify('');
    if (!this.workspaceFocused) { this.focusHeading(); this.workspaceFocused = true; }
  };
  Controller.prototype.renderGroupContributions = function (container) {
    var self = this, g = this.group;
    var payments = el('section', 'fb-group__section');
    append(
      payments,
      el(
        'h2',
        '',
        g.role === 'organiser' ? 'Contributions' : 'Your contributions'
      )
    );
    var list = el('ul', 'fb-group__list');
    (g.contributions || []).forEach(function (c) {
      var row = el('li', 'fb-group__row');
      var info = el('div');
      append(
        info,
        el('strong', '', c.contributorName || 'Your contribution'),
        el('p', '', PAYMENT_STATES[c.state] || 'Checking payment status')
      );
      if (c.refundedCents)
        append(info, el('small', '', money(c.refundedCents) + ' refunded'));
      if (c.refundPendingCents)
        append(
          info,
          el('small', '', money(c.refundPendingCents) + ' refund in progress')
        );
      append(info, paymentAttention(c));
      append(row, info, el('strong', '', money(c.amountCents)));
      if (c.canResume && safeCheckout(c.checkoutUrl, 'contribution'))
        append(
          row,
          link(
            'Continue secure payment',
            safeCheckout(c.checkoutUrl, 'contribution'),
            'fb-group__button fb-group__button--secondary'
          )
        );
      if (
        (g.role === 'contributor' || c.isOwn) &&
        ['initiated', 'pending', 'refund_pending'].includes(c.state)
      )
        append(
          row,
          button(
            'Check payment status',
            function (event) {
              self.perform(
                async function () {
                  await self.request(
                    self.endpoint('/contributions/' + encodeURIComponent(c.id))
                  );
                  await self.load();
                  self.notify('Payment status updated.');
                },
                event.currentTarget,
                'Checking your payment…'
              );
            },
            true
          )
        );
      if (c.canRefund || c.canWithdraw)
        append(
          row,
          button(
            'Request refund',
            function () {
              self.confirmDrawer(
                'Request a refund',
                'We’ll check that these funds have not been committed to a gift. A request does not confirm a refund; its progress will appear here.',
                'Request refund',
                '/contributions/' + encodeURIComponent(c.id) + '/refund'
              );
            },
            true
          )
        );
      append(list, row);
    });
    append(payments, list);
    if (!(g.contributions || []).length)
      append(
        payments,
        el(
          'p',
          'fb-group__muted',
          g.role === 'organiser'
            ? 'No contributions yet. Share the invitation when you’re ready.'
            : 'You haven’t contributed yet. You can explore ideas before deciding.'
        )
      );
    append(container, payments);
    if (g.role === 'organiser' && g.members && g.members.length)
      this.renderMembers(container);
  };
  Controller.prototype.renderPaymentHistory = function (history) {
    var self = this;
    this.shell();
    append(
      this.mount,
      el('h1', '', 'Your contribution records'),
      el(
        'p',
        '',
        'You no longer have access to this group. Your payment history and any eligible refunds remain available here.'
      )
    );
    var list = el('ul', 'fb-group__list');
    (history.contributions || []).forEach(function (c) {
      var row = el('li', 'fb-group__row');
      var info = el('div');
      append(
        info,
        el('strong', '', money(c.amountCents)),
        el('p', '', PAYMENT_STATES[c.state] || 'Checking payment status')
      );
      if (c.refundedCents)
        append(info, el('small', '', money(c.refundedCents) + ' refunded'));
      if (c.refundPendingCents)
        append(
          info,
          el('small', '', money(c.refundPendingCents) + ' refund in progress')
        );
      append(info, paymentAttention(c));
      append(row, info);
      if (c.canRefund || c.canWithdraw)
        append(
          row,
          button(
            'Request refund',
            function () {
              self.confirmDrawer(
                'Request a refund',
                'We’ll check that these funds have not been committed to a gift. Your payment rights are retained even though you no longer have group access.',
                'Request refund',
                '/contributions/' + encodeURIComponent(c.id) + '/refund'
              );
            },
            true
          )
        );
      if (['initiated', 'pending', 'refund_pending'].includes(c.state))
        append(
          row,
          button(
            'Check payment status',
            function (event) {
              self.perform(
                async function () {
                  await self.request(
                    self.endpoint('/contributions/' + encodeURIComponent(c.id))
                  );
                  var result = await self.request(
                    self.endpoint('/contributions')
                  );
                  self.renderPaymentHistory(result);
                },
                event.currentTarget,
                'Checking your payment…'
              );
            },
            true
          )
        );
      append(list, row);
    });
    append(this.mount, list);
    this.focusHeading();
  };
  Controller.prototype.renderMembers = function (container) {
    var self = this;
    var section = el('section', 'fb-group__section');
    append(section, el('h2', '', 'People giving together'));
    var list = el('ul', 'fb-group__list');
    this.group.members.forEach(function (m) {
      var row = el('li', 'fb-group__row');
      append(
        row,
        el('span', '', m.name),
        m.revokedAt
          ? el('small', '', 'Access removed')
          : m.canRevoke
            ? button(
                'Remove access',
                function () {
                  self.confirmDrawer(
                    'Remove group access',
                    m.name +
                      ' will no longer see this group. Their payment records and any refund rights are retained.',
                    'Remove access',
                    '/members/' + encodeURIComponent(m.id) + '/revoke'
                  );
                },
                true
              )
            : null
      );
      append(list, row);
    });
    append(section, list);
    append(container, section);
  };
  Controller.prototype.renderPurchase = function (container, purchase) {
    var self = this;
    var box = el('section', 'fb-group__notice');
    append(
      box,
      el('strong', '', PURCHASE_STATES[purchase.state] || 'Checking your order')
    );
    if (purchase.orderName)
      append(box, el('p', '', 'Order ' + purchase.orderName));
    if (purchase.message) append(box, el('p', '', purchase.message));
    if (purchase.state === 'completed') this.renderOrderSummary(box, purchase.orderSummary);
    if (purchase.state === 'pending' || purchase.state === 'preparing')
      append(
        box,
        el(
          'p',
          '',
          'Your funds remain reserved while we check. Please check this same attempt before trying to order again.'
        )
      );
    if (this.group.role === 'organiser') {
      if (purchase.state !== 'completed')
        append(
          box,
          button(
            'Check order status',
            function (event) {
              self.perform(
                async function () {
                  var checked = await self.request(self.endpoint('/purchase'));
                  await self.load();
                  if (checked.purchase) {
                    self.group.purchase = checked.purchase;
                    self.renderGroup();
                  }
                },
                event.currentTarget,
                'Checking the same order attempt…'
              );
            },
            true
          )
        );
    }
    append(container, box);
  };
  Controller.prototype.suspendPlanningForSignIn = function (error) {
    if (this.planningBlocked) return;
    this.identityVersion++;
    this.planningBlocked = true;
    this.error(error);
    if (this.reviewView) this.reviewView.hidePrivate();
    this.resumeAfterSignIn = {
      memberId: this.me && this.me.member && this.me.member.id, dialogOpen: Boolean(this.dialog && this.dialog.open), view: this.view, id: this.id,
      occasionId: this.occasion && this.occasion.id, role: this.group && this.group.role,
      state: this.group && this.group.state, permissions: this.group && JSON.stringify(this.group.permissions)
    };
    var self = this, retained = [], barriers = [], dialog = this.dialog, drawerVersion = this.drawerVersion;
    var heading = dialog && dialog.querySelector('h2'), title = heading && heading.textContent;
    function conceal(container) {
      if (!container) return;
      Array.from(container.children).forEach(function (node) { retained.push({ node: node, hidden: node.hidden, parent: container }); node.hidden = true; });
      var barrier = el('div', 'fb-group__auth-recovery');
      var message = el('p', 'fb-group__error', error.message || 'Sign in again to continue.'); message.setAttribute('role', 'alert');
      append(barrier, message, el('p', '', 'Sign in with the same account to review your saved work and continue.'));
      self.addSignIn(barrier); append(container, barrier); barriers.push(barrier);
    }
    [this.mount, this.entry, this.listMount].forEach(conceal);
    if (dialog && dialog.open) { conceal(dialog.querySelector('.fb-group__dialog-body')); if (heading) heading.textContent = 'Sign in to continue'; }
    this.resumePlanning = function () {
      self.planningBlocked = false; self.resumePlanning = null;
      barriers.forEach(function (node) { node.remove(); });
      retained.forEach(function (entry) { if (entry.node.parentNode === entry.parent) entry.node.hidden = entry.hidden; });
      if (heading && self.dialog === dialog && self.drawerVersion === drawerVersion) heading.textContent = title;
      if (self.group) self.renderGroup();
    };
  };
  Controller.prototype.recoverPlanningAccess = async function (error) {
    if (error && (error.code === 'UNAUTHENTICATED' || error.status === 401)) {
      this.suspendPlanningForSignIn(error); return;
    }
    if (!error || (!['FORBIDDEN', 'NOT_FOUND'].includes(error.code) && ![403, 404].includes(error.status)) || !this.group) return;
    // Product unavailability and revoked group access both use NOT_FOUND.
    // A fresh member-authorised read distinguishes them without trusting cached access.
    var identity = this.identityVersion;
    try {
      var latest = await this.request(this.endpoint());
      if (identity !== this.identityVersion) return;
      var group = latest.group || latest;
      var changed = group.role !== this.group.role || group.state !== this.group.state || JSON.stringify(group.permissions) !== JSON.stringify(this.group.permissions);
      this.group = group;
      if (changed) {
        this.identityVersion++;
        if (this.productDetails) this.productDetails.dispose(); this.productDetails = null;
        if (this.planModel) this.planModel.dispose(); this.planModel = null;
        this.closeDrawer(true, true);
      }
      this.renderGroup();
    } catch (accessError) {
      if (identity !== this.identityVersion) return;
      if (accessError.code === 'UNAUTHENTICATED' || accessError.status === 401) { this.suspendPlanningForSignIn(accessError); return; }
      var denied = ['FORBIDDEN', 'NOT_FOUND'].includes(accessError.code) || [403, 404].includes(accessError.status);
      this.clearPrivateState(); this.shell();
      append(this.mount, el('h1', '', denied ? 'This group gift is no longer available' : 'We couldn’t recheck access to this group gift'));
      this.error(accessError);
      var self = this; append(this.mount, button('Try again', function () { return self.load(); }, true));
    }
  };
  Controller.prototype.requestPlanning = function (path, payload, method) {
    var self = this, identity = this.identityVersion;
    async function request() {
      if (identity !== self.identityVersion) throw { code: 'STALE_SESSION' };
      if (self.planningBlocked) throw { code: 'UNAUTHENTICATED', status: 401, message: 'Sign in again to continue.' };
      try {
        var result = await self.request(path, payload, method);
        if (identity !== self.identityVersion) throw { code: 'STALE_SESSION' };
        return result;
      } catch (error) { await self.recoverPlanningAccess(error); throw error; }
    }
    if (payload == null) return request();
    var queued = Promise.resolve(this.planningWrite).catch(function () {}).then(request);
    this.planningWrite = queued.catch(function () {});
    return queued;
  };
  Controller.prototype.planActions = function () {
    if (!this.planModel) {
      var self = this;
      this.planModel = root.FBGroupGiftsPlan.create({
        getGroup: function () { return self.group; },
        key: function () { return uniqueKey(); },
        request: function (path, payload, method) { return self.requestPlanning(self.endpoint(path), payload, method); },
        onGroup: function (group) {
          self.group = group; self.quote = null; self.archivedIdeas = null; self.archiveError = null;
          self.archiveLoading = false; self.archiveGeneration = (self.archiveGeneration || 0) + 1;
          self.renderGroup();
        },
        onChange: function (state) {
          if (self.mount) {
            var status = self.mount.querySelector('.fb-group__plan-feedback');
            if (status) self.renderPlanFeedback(status);
            self.mount.querySelectorAll('[data-group-choose]').forEach(function (control) { control.disabled = state.saving; });
          }
        }
      });
    }
    return this.planModel;
  };
  Controller.prototype.renderPlanFeedback = function (container) {
    var self = this, state = this.planModel && this.planModel.state;
    container.textContent = '';
    if (!state) return;
    var message = el('p', state.error ? 'fb-group__error' : 'fb-group__status', state.error ? state.error.message : state.saving ? 'Saving changes…' : state.notice);
    message.setAttribute('role', state.error ? 'alert' : 'status'); append(container, message);
    if (state.undo) { var undo = button('Undo removal', function () { return self.planActions().undo(); }, true); undo.disabled = state.saving; append(container, undo); }
  };
  Controller.prototype.productCard = function (product, suggestion, options) {
    var self = this, group = this.group || { permissions: {}, recipientName: options && options.context && options.context.name };
    var card = el('article', 'fb-group__product');
    var variant = String(product.variantId || '');
    var chosen = Boolean(suggestion && group.plan && group.plan.items.some(function (item) { return item.suggestionId === suggestion.id; }));
    if (chosen) card.classList.add('fb-group__product--selected');
    var media = el('div', 'fb-group__media');
    var src = safeImage(product.image);
    if (src) {
      var image = el('img');
      image.src = src;
      image.alt = product.imageAlt || product.title || '';
      image.loading = 'lazy';
      image.width = 400;
      image.height = 500;
      image.addEventListener(
        'error',
        function () {
          media.textContent = '';
          append(media, el('span', '', 'Image unavailable'));
        },
        { once: true }
      );
      append(media, image);
    } else append(media, el('span', '', 'Image unavailable'));
    var info = el('div', 'fb-group__product-info');
    var title = el('h3');
    append(title, el('span', '', product.title || 'Gift'));
    var details = button('View gift details', function () { return options && options.onDetails ? options.onDetails() : self.productDrawer(product); }, true);
    details.dataset.groupProductDetails = product.handle;
    append(info, title, el('p', '', product.variantLabel || 'Gift option'), el('strong', '', money(product.priceCents)), details);
    if (product.priceCents == null && Number.isSafeInteger(product.savedPriceCents)) append(info, el('p', 'fb-group__muted', 'Last saved price · ' + money(product.savedPriceCents) + '. Current price not checked.'));
    if (product.availability === 'unavailable') append(info, el('p', 'fb-group__error', 'This option is unavailable. View details to choose another size, or remove it from the chosen gifts.'));
    else if (product.availability === 'unknown') append(info, el('p', 'fb-group__muted', 'Availability needs checking before you confirm gifts.'));
    if (suggestion)
      append(
        info,
        el('p', 'fb-group__muted', 'Suggested by ' + suggestion.suggestedBy)
      );
    var evidence = suggestion ? suggestion.recipientEvidence : product.evidence;
    if (
      evidence &&
      ['loved', 'wishlist', 'recipient_loved', 'recipient_wishlist'].includes(
        evidence.kind
      )
    )
      append(
        info,
        el(
          'p',
          'fb-group__evidence',
          '♥ ' +
            group.recipientName +
            (evidence.kind === 'loved' || evidence.kind === 'recipient_loved'
              ? ' loves this'
              : ' saved this')
        )
      );
    if (suggestion && group.permissions.canSelectGift && variant) {
      if (chosen) append(info, el('p', 'fb-group__status', 'Chosen for gift'));
      var choose = button(chosen ? 'Remove from chosen gifts' : 'Choose for gift', function () {
        return self.planActions().choose(suggestion.id, !chosen);
      }, !chosen);
      choose.disabled = Boolean(this.planModel && this.planModel.state.saving);
      choose.setAttribute('aria-label', (chosen ? 'Remove from chosen gifts: ' : 'Choose for gift: ') + product.title + ' · ' + (product.variantLabel || 'Gift option'));
      choose.setAttribute('data-group-choose', '');
      choose.setAttribute('aria-pressed', String(chosen));
      append(info, choose);
      if (chosen) append(info, button('Change size', function () { return self.productDrawer(product, suggestion); }, true));
    }
    if (suggestion && (group.permissions.canComment || (suggestion.comments || []).length))
      append(
        info,
        button(
          'Comments' +
            (suggestion.comments.length
              ? ' (' + suggestion.comments.length + ')'
              : ''),
          function () {
            self.commentDrawer(suggestion);
          },
          true
        )
      );
    if (suggestion && suggestion.permissions && suggestion.permissions.canArchive && group.permissions.canSuggest !== false)
      append(info, button(group.role === 'organiser' ? 'Remove idea' : 'Withdraw my idea', function () { return self.archiveDrawer(suggestion, chosen); }, true));
    append(card, media, info);
    return card;
  };
  Controller.prototype.archiveDrawer = function (suggestion, chosen) {
    var self = this;
    if (!chosen && !(suggestion.comments || []).length) return this.planActions().archive(suggestion);
    var body = this.openDrawer('Remove this idea?');
    append(body, el('h3', '', suggestion.product && suggestion.product.title || suggestion.productHandle || 'Gift idea'),
      el('p', '', 'This idea will move to Removed ideas. Its discussion will be preserved.'),
      chosen ? el('p', '', 'It will also be removed from the chosen gifts. You will need to confirm and review the updated choices before ordering.') : null);
    var error = el('p', 'fb-group__error'); error.setAttribute('role', 'alert');
    var confirm = button('Remove idea', async function () {
      var actions = self.planActions(), identity = self.identityVersion, drawerVersion = self.drawerVersion;
      confirm.disabled = true; await actions.archive(suggestion);
      if (identity !== self.identityVersion || drawerVersion !== self.drawerVersion) return;
      confirm.disabled = false;
      if (actions.state.error) error.textContent = actions.state.error.message;
      else self.closeDrawer();
    });
    append(body, error, confirm, button('Keep idea', function () { self.closeDrawer(); }, true));
  };
  Controller.prototype.productDrawer = function (product, replaceSuggestion, setup, restoring) {
    var self = this;
    if (!setup && !restoring) this.writeProductRoute(product, false);
    if (this.productDetails) this.productDetails.dispose();
    var focused = root.document.activeElement;
    var body = this.openDrawer(product.title || 'Gift details', { kind: 'product', handle: product.handle,
      catalogue: Boolean(focused && focused.closest && focused.closest('.fb-group__catalogue-grid')), setup: Boolean(setup) });
    var content = el('div', 'fb-group__product-detail');
    append(body, content);
    var model = root.FBGroupGiftsProduct.create({
      request: function (path, payload) {
        if (!setup) return self.requestPlanning(self.endpoint(path), payload);
        var url = new URL('/group-gifts/catalogue' + path.slice(5), root.location.origin);
        url.searchParams.set(setup.occasionId ? 'occasionId' : 'friendId', setup.occasionId || setup.friendId);
        return self.requestPlanning(url.pathname + url.search);
      },
      key: function () { return uniqueKey(); },
      onGroup: function (group) { self.group = group; self.quote = null; self.renderGroup(); },
      onChange: function () { render(); }
    });
    this.productDetails = model;
    function render() {
      var state = model.state, focused = root.document.activeElement;
      var focusName = focused && focused.name;
      content.textContent = '';
      content.setAttribute('aria-busy', String(state.loading || state.saving));
      var status = el('p', 'fb-group__status', state.loading ? 'Loading gift details…' : state.saving ? 'Saving…' : '');
      status.setAttribute('role', 'status'); append(content, status);
      if (state.error) { var error = el('p', 'fb-group__error', state.error.message || 'Couldn’t save this gift. Try again.'); error.setAttribute('role', 'alert'); append(content, error); }
      if (!state.product) {
        if (!state.loading) append(content, button('Try again', function () { return model.open(product.handle, product.variantId); }, true));
        return;
      }
      var detail = state.product, src = safeImage(detail.image);
      if (src) { var image = el('img', 'fb-group__detail-image'); image.src = src; image.alt = detail.imageAlt || detail.title; append(content, image); }
      append(content, el('h3', '', detail.title), el('p', 'fb-group__description', detail.description));
      var label = el('label', '', 'Choose an option'), select = el('select');
      select.name = 'gift-option'; select.disabled = state.saving || state.loading;
      if (!state.variant) { var missing = el('option', '', 'Choose an available option'); missing.value = ''; append(select, missing); }
      detail.variants.forEach(function (variant) { var option = el('option', '', variant.variantLabel + ' · ' + money(variant.priceCents)); option.value = variant.variantId; append(select, option); });
      select.value = state.variant ? state.variant.variantId : '';
      select.addEventListener('change', function () {
        if (!select.value) return;
        if (!setup) self.writeProductRoute({ handle: detail.handle, variantId: select.value }, true);
        return model.select(select.value);
      });
      append(label, select); append(content, label, el('p', 'fb-group__muted', 'Item price only. Delivery is extra. Adding an idea does not place an order.'));
      if (setup) {
        var use = button('Use this gift idea', function () {
          if (!state.variant) return;
          self.setupIdea = { productHandle: detail.handle, variantId: state.variant.variantId, title: detail.title,
            variantLabel: state.variant.variantLabel, priceCents: state.variant.priceCents };
          return setup.onUse(self.setupIdea);
        });
        use.disabled = state.loading || !state.variant;
        append(content, use, button('Back to gifts', function () { return setup.onBack(); }, true));
        return;
      }
      if (replaceSuggestion) {
        append(content, el('p', '', 'The new size will be chosen. The original idea and discussion stay on the shortlist.'));
        var change = button('Choose this size', async function () {
          var actions = self.planActions(), identity = self.identityVersion, drawerVersion = self.drawerVersion;
          var payload = { productHandle: detail.handle, variantId: state.variant.variantId };
          if (state.suggestion && state.suggestion.archivedAt) payload.expectedSuggestionVersion = state.suggestion.version;
          change.disabled = true; select.disabled = true; await actions.replace(replaceSuggestion.id, payload);
          if (identity !== self.identityVersion || drawerVersion !== self.drawerVersion) return;
          if (actions.state.error) { var error = el('p', 'fb-group__error', actions.state.error.message); error.setAttribute('role', 'alert'); append(content, error); change.disabled = false; select.disabled = false; }
          else self.closeDrawer();
        });
        change.setAttribute('aria-label', 'Choose this size: ' + detail.title + ' · ' + (state.variant && state.variant.variantLabel || 'Gift option'));
        change.disabled = state.loading || state.saving || !state.variant || root.FBGroupGiftsProduct.canonical(state.variant.variantId) === root.FBGroupGiftsProduct.canonical(product.variantId);
        select.disabled = Boolean(self.planModel && self.planModel.state.saving);
        append(content, change, button('Keep current size', function () { self.closeDrawer(); }, true));
        return;
      }
      if (state.removed) { var removed = el('p', '', 'Idea removed from the shortlist.'); removed.setAttribute('role', 'status'); append(content, removed); }
      if (state.saved) {
        var change = state.saved.change;
        var shortlistName = self.group.name ? self.group.name + '’s shortlist' : 'the shortlist';
        var message = change.currentState === 'archived' ? 'This idea has since been removed.'
          : detail.title + ' · ' + state.variant.variantLabel + (change.kind === 'existing' ? ' is already on the shortlist.' : change.kind === 'restored' ? ' restored to ' + shortlistName + '.' : ' added to ' + shortlistName + '.');
        var success = el('p', 'fb-group__status', message); success.setAttribute('role', 'status'); append(content, success);
        if (change.currentState === 'active') {
          var saved = button('On the shortlist'); saved.disabled = true; append(content, saved);
          if (self.group.permissions.canSelectGift) {
            var alreadyChosen = self.group.plan.items.some(function (item) { return item.suggestionId === change.suggestionId; });
            var choose = button(alreadyChosen ? 'Chosen for gift' : 'Choose for gift', async function () {
              var actions = self.planActions(), identity = self.identityVersion, drawerVersion = self.drawerVersion;
              choose.disabled = true; await actions.choose(change.suggestionId, true);
              if (identity !== self.identityVersion || drawerVersion !== self.drawerVersion) return;
              if (actions.state.error) { var error = el('p', 'fb-group__error', actions.state.error.message); error.setAttribute('role', 'alert'); append(content, error); choose.disabled = false; }
              else render();
            }, true);
            choose.setAttribute('aria-label', (alreadyChosen ? 'Chosen for gift: ' : 'Choose for gift: ') + detail.title + ' · ' + state.variant.variantLabel);
            choose.disabled = alreadyChosen || state.saving || Boolean(self.planModel && self.planModel.state.saving); append(content, choose);
          } else append(content, el('p', 'fb-group__muted', (self.group.organiserName || 'The organiser') + ' will choose the final gifts.'));
        }
        append(content, button('View shortlist', function () {
          self.navigateSection('shortlist');
        }, true));
        if (change.undoable && change.currentState === 'active') { var undo = button('Undo', function () { return model.undo(); }, true); undo.disabled = state.saving; append(content, undo); }
      } else if (self.group.permissions.canSuggest) {
        var add = button('Add to shortlist', function () { return model.add(); }); add.name = 'gift-add'; add.disabled = state.loading || state.saving || !state.variant; append(content, add);
      }
      append(content, button('Keep browsing', function () { self.closeDrawer(); }, true));
      if (focusName) { var next = content.querySelector('[name="' + focusName + '"]'); if (next) next.focus(); }
    }
    return model.open(product.handle, product.variantId);
  };
  Controller.prototype.renderPreviousChoices = async function (container) {
    var self = this, g = this.group, saved = this.savedSelection;
    var generation = this.previousChoicesGeneration = (this.previousChoicesGeneration || 0) + 1;
    if (!g || g.role !== 'organiser' || g.state !== 'closed' || !g.plan || g.plan.initialized || !saved || !Array.isArray(saved.lines) || !saved.lines.length) return;
    var identity = this.identityVersion, version = g.plan.version;
    function current() { return identity === self.identityVersion && generation === self.previousChoicesGeneration && self.group && self.group.id === g.id && self.group.role === 'organiser' && self.group.state === 'closed' && !self.group.plan.initialized && self.group.plan.version === version && panel.isConnected; }
    function canonical(id) { return String(id || '').split('/').pop(); }
    var panel = el('section', 'fb-group__previous-choices');
    append(container, panel); append(panel, el('h3', '', 'Previous choices'), el('p', '', 'These are saved choices from an earlier delivery review. They have not been added to the chosen gifts.'));
    var matches = saved.lines.map(function (line) {
      var idea = (g.suggestions || []).find(function (item) { return !item.archivedAt && canonical(item.variantId) === canonical(line.variantId); });
      var product = idea && idea.product;
      append(panel, el('p', '', (product ? product.title + ' · ' + (product.variantLabel || 'Option not recorded') : 'Saved gift · option ' + canonical(line.variantId)) + ' × ' + line.quantity));
      return idea;
    });
    var status = el('p', 'fb-group__muted', 'Checking every saved option…'); status.setAttribute('role', 'status'); append(panel, status);
    function replacements() { status.textContent = 'These previous choices cannot all be restored. Choose replacement gifts from the shortlist, then confirm and review a new delivery total.'; }
    var ids = matches.filter(Boolean).map(function (idea) { return idea.id; });
    if (!g.permissions.canEditPlan || saved.lines.length > 30 || ids.length !== saved.lines.length || new Set(ids).size !== ids.length || saved.lines.some(function (line) { return line.quantity !== 1; })) { replacements(); return; }
    try {
      var checks = await Promise.all(matches.map(function (idea) { return self.request(self.endpoint('/shop/' + encodeURIComponent(idea.productHandle) + '?variantId=' + encodeURIComponent(idea.variantId))); }));
      if (!current()) return;
      var eligible = checks.every(function (result, index) { return result.product && (result.product.variants || []).some(function (option) { return canonical(option.variantId) === canonical(saved.lines[index].variantId); }) && result.suggestion && result.suggestion.id === ids[index] && !result.suggestion.archivedAt; });
      if (!eligible) { replacements(); return; }
      status.textContent = 'Every previous choice is available. Restore all gifts together, then confirm them and check a new delivery total.';
      var feedback = el('p'); feedback.setAttribute('role', 'status');
      var restore = button('Restore previous choices', async function () {
        if (!current() || !self.group.permissions.canEditPlan) return;
        var actions = self.planActions(); restore.disabled = true;
        await actions.restorePrevious(ids);
        if (identity !== self.identityVersion || generation !== self.previousChoicesGeneration) return;
        restore.disabled = false;
        feedback.textContent = actions.state.error ? actions.state.error.message : actions.state.notice;
      });
      append(panel, restore, feedback);
    } catch (error) {
      if (!current()) return;
      if (error.code === 'UNAUTHENTICATED') { panel.hidden = true; this.error(error); return; }
      status.textContent = 'We could not check every previous option. Refresh the shortlist to check again, or choose replacement gifts.';
    }
  };
  Controller.prototype.renderShortlist = function (container, options) {
    options = options || {};
    var self = this, completed = this.group.state === 'completed' && this.group.purchase && this.group.purchase.state === 'completed';
    var section = el('section', 'fb-group__section');
    append(
      section,
      el('h2', '', 'Shortlist'),
      el(
        'p',
        'fb-group__muted',
        completed ? 'The ordered gifts are shown below. Earlier ideas and discussion remain available.' : this.group.role === 'organiser'
          ? 'Choose the gift from everyone’s ideas. Products are not reserved until the order is confirmed.'
          : 'Share an idea or leave a brief comment. ' +
              this.group.organiserName +
              ' will make the final choice.'
      )
    );
    this.renderPreviousChoices(section);
    var plan = this.group.plan || { items: [], itemSubtotalCents: null };
    var ideas = this.group.suggestions || [], chosenIds = new Set(plan.items.map(function (item) { return item.suggestionId; }));
    if (completed) this.renderOrderSummary(section, this.group.purchase.orderSummary);
    else {
      if ((plan.unavailableSuggestionIds || []).length) {
        var unavailable = el('p', 'fb-group__error', 'A chosen option is unavailable. Change size, remove it or find another gift before confirming.');
        unavailable.setAttribute('role', 'alert'); append(section, unavailable);
      } else if (plan.needsAvailabilityCheck) {
        var unchecked = el('p', 'fb-group__muted', 'Current prices and availability could not be checked. Refresh before confirming gifts.');
        unchecked.setAttribute('role', 'status'); append(section, unchecked);
      }
      if (options.showConfirm !== false && this.canOpenJourneyStep('confirm') && plan.confirmedVersion !== plan.version)
        append(section, button('Confirm chosen gifts', function () { self.confirmGiftsDrawer(); }));
      var feedback = el('div', 'fb-group__plan-feedback'); this.renderPlanFeedback(feedback);
      append(section, feedback, el('h3', '', 'Chosen for gift'));
      var productOptions = new Map();
      plan.items.forEach(function (item) {
        var idea = ideas.find(function (s) { return s.id === item.suggestionId; });
        var product = item.product || (idea && idea.product);
        if (!product || !product.handle) return;
        if (!productOptions.has(product.handle)) productOptions.set(product.handle, []);
        productOptions.get(product.handle).push(product);
      });
      productOptions.forEach(function (options) {
        if (options.length < 2) return;
        var notice = el('div', 'fb-group__status'); notice.setAttribute('role', 'status');
        append(notice, el('p', '', 'You have ' + (options.length === 2 ? 'two' : String(options.length)) + ' options of this product chosen: ' + options[0].title + '. Review them to check that you want these options.'));
        var review = el('div', 'fb-group__actions');
        options.forEach(function (product) { append(review, button('Review ' + product.title + ' · ' + product.variantLabel, function () { return self.productDrawer(product); }, true)); });
        append(notice, review); append(section, notice);
      });
      var chosen = el('div', 'fb-group__shortlist');
      plan.items.forEach(function (item) {
        var idea = ideas.find(function (s) { return s.id === item.suggestionId; });
        if (idea) append(chosen, self.productCard(item.product || idea.product, { ...idea, comments: idea.comments || [] }));
      });
      if (!plan.items.length) append(chosen, el('p', '', self.group.role === 'organiser' ? 'Choose from the shortlist when you’re ready. Your choices will be saved here.' : 'The organiser has not chosen gifts yet.'));
      append(section, chosen);
      var summary = el('div', 'fb-group__plan-summary');
      append(summary, pair('Item estimate', plan.itemSubtotalCents === null ? 'Check current prices' : money(plan.itemSubtotalCents)),
        el('p', 'fb-group__muted', 'Delivery not yet quoted'),
        pair('Confirmed available funds', money(this.group.budget && this.group.budget.availableCents)));
      var available = this.group.budget && this.group.budget.availableCents;
      if (Number.isSafeInteger(plan.itemSubtotalCents) && Number.isSafeInteger(available) && plan.itemSubtotalCents > available)
        append(summary, pair('Item shortfall before delivery', money(plan.itemSubtotalCents - available)));
      append(summary, el('p', 'fb-group__muted', 'These are planning amounts. Nothing has been ordered.'));
      append(section, summary);
    }
    append(section, el('h3', '', completed ? 'Earlier ideas' : 'Other ideas'));
    var cards = el('div', 'fb-group__shortlist');
    ideas.filter(function (s) { return completed || !chosenIds.has(s.id); }).forEach(function (s) {
      var product = s.product || {
        handle: s.productHandle, title: s.productTitle || s.productHandle,
        priceCents: s.priceCents, variantId: s.variantId, variantLabel: s.variantLabel,
        image: s.image, url: '/products/' + s.productHandle
      };
      append(cards, self.productCard(product, { ...s, comments: s.comments || [] }));
    });
    if (!cards.children.length) append(cards, el('p', '', completed ? 'No other ideas were saved.' : 'No other ideas yet. Find another gift to suggest.'));
    append(section, cards);
    if (!completed && !(this.group.suggestions || []).length)
      append(
        section,
        el(
          'p',
          '',
          'The first idea can be yours. Explore gifts below to start the shortlist.'
        )
      );
    this.renderRemovedIdeas(section);
    append(container, section);
  };
  Controller.prototype.renderRemovedIdeas = function (container) {
    var self = this, details = el('details', 'fb-group__removed-ideas');
    details.open = Boolean(this.archiveExpanded);
    append(details, el('summary', '', 'Removed ideas'));
    var content = el('div'); append(details, content); append(container, details);
    function render() {
      content.textContent = '';
      if (self.archiveLoading) { var loading = el('p', '', 'Loading removed ideas…'); loading.setAttribute('role', 'status'); append(content, loading); return; }
      if (self.archiveError) {
        var error = el('p', 'fb-group__error', 'Couldn’t load removed ideas. Try again.'); error.setAttribute('role', 'alert');
        append(content, error, button('Try again', load, true)); return;
      }
      if (!self.archivedIdeas) return;
      if (!self.archivedIdeas.length) append(content, el('p', '', 'No removed ideas.'));
      self.archivedIdeas.forEach(function (idea) {
        var product = idea.product || {}, card = el('article', 'fb-group__archived-idea');
        append(card, el('h4', '', product.title || idea.productHandle), el('p', '', product.variantLabel || 'Gift option'),
          el('p', 'fb-group__muted', 'Suggested by ' + idea.suggestedBy));
        (idea.comments || []).forEach(function (comment) { append(card, el('p', '', comment.authorName + ': ' + comment.text)); });
        if (idea.permissions.canRestore && self.group.permissions.canSuggest !== false) {
          var restore = button('Restore to Other ideas', function () { return self.planActions().restore(idea); }, true);
          restore.disabled = Boolean(self.planModel && self.planModel.state.saving); append(card, restore);
        }
        append(content, card);
      });
    }
    async function load() {
      if (self.archiveLoading) return;
      var generation = self.archiveGeneration || 0;
      self.archiveLoading = true; self.archiveError = null; render();
      try {
        var result = await self.request(self.endpoint('/suggestions?state=archived'));
        if (generation !== (self.archiveGeneration || 0)) return;
        self.archivedIdeas = result.suggestions;
      } catch (error) { if (generation === (self.archiveGeneration || 0)) self.archiveError = error; }
      finally {
        if (generation === (self.archiveGeneration || 0)) { self.archiveLoading = false; render(); self.renderGroup(); }
      }
    }
    details.addEventListener('toggle', function () {
      self.archiveExpanded = details.open;
      if (details.open && !self.archivedIdeas && !self.archiveError) return load();
    });
    render();
    if (details.open && !self.archivedIdeas && !self.archiveError) load();
  };
  Controller.prototype.commentDrawer = function (suggestion) {
    var self = this;
    var body = this.openDrawer('Comments on this gift');
    append(
      body,
      el(
        'h3',
        '',
        (suggestion.product && suggestion.product.title) ||
          suggestion.productHandle
      )
    );
    var comments = el('div', 'fb-group__comments');
    (suggestion.comments || []).forEach(function (c) {
      append(
        comments,
        append(
          el('article', 'fb-group__comment'),
          el('strong', '', c.authorName),
          el('p', '', c.text)
        )
      );
    });
    append(body, comments);
    if (!this.group.permissions.canComment) {
      append(body, el('p', 'fb-group__muted', 'This discussion is read-only.'));
      return;
    }
    var form = el('form');
    field(form, 'comment', 'Your comment', 'textarea', '', {
      required: '',
      maxlength: '500',
      help: 'Keep it about this gift. Comments are shared with the group.'
    });
    var submit = button('Add comment');
    submit.type = 'submit';
    append(form, append(el('div', 'fb-group__actions'), submit));
    append(body, form);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      var payload = { text: form.elements.comment.value.trim() };
      payload.idempotencyKey = self.key('comment:' + suggestion.id, payload);
      self.perform(async function () {
        await self.request(
          self.endpoint(
            '/suggestions/' + encodeURIComponent(suggestion.id) + '/comments'
          ),
          payload
        );
        self.closeDrawer();
        await self.load();
        self.notify('Comment added.');
      }, submit);
    });
  };
  Controller.prototype.renderShop = function (container, setup) {
    var self = this, modelKey = setup ? 'setupCatalogue' : 'catalogue', viewKey = setup ? 'setupCatalogueView' : 'catalogueView';
    var catalogue = this[modelKey];
    if (!catalogue) catalogue = this[modelKey] = root.FBGroupGiftsCatalogue.create({
      request: function (criteria) {
        var params = new URLSearchParams(criteria);
        if (setup) params.set(setup.occasionId ? 'occasionId' : 'friendId', setup.occasionId || setup.friendId);
        return self.request(setup ? '/group-gifts/catalogue?' + params.toString() : self.endpoint('/shop?' + params.toString()));
      },
      onChange: function () { self.renderCatalogueResults(setup); }
    });
    var state = catalogue.state;
    var section = el('section', 'fb-group__section fb-group__catalogue');
    append(section, el('h2', '', setup ? 'Find gifts for ' + setup.name : 'Find gifts'),
      el('p', 'fb-group__muted', 'Delivery extra; ideas aren’t orders.'));
    var form = el('form', 'fb-group__catalogue-filters');
    var search = field(form, 'catalogue-search', 'Search gifts, flowers and cards', 'search', state.query.q, { maxlength: 100 });
    var nav = el('div', 'fb-group__categories');
    nav.setAttribute('role', 'group'); nav.setAttribute('aria-label', 'Gift categories');
    var category = state.query.category, categoryButtons = [];
    function price(value) {
      if (!value.trim()) return null;
      if (!/^\d+(?:\.\d{1,2})?$/.test(value.trim())) return undefined;
      var parts = value.trim().split('.');
      var amount = Number(parts[0]) * 100 + Number(((parts[1] || '') + '00').slice(0, 2));
      return Number.isSafeInteger(amount) ? amount : undefined;
    }
    [['all', 'All gifts'], ['flowers', 'Flowers'], ['gifts', 'Gifts'], ['cards', 'Cards']].forEach(function (choice) {
      var control = button(choice[1], function () { category = choice[0]; apply(); }, true);
      control.setAttribute('aria-pressed', String(category === choice[0]));
      categoryButtons.push({ id: choice[0], element: control }); append(nav, control);
    });
    append(form, nav);
    var filters = el('details', 'fb-group__catalogue-options');
    filters.open = Boolean(this[viewKey] && this[viewKey].filters && this[viewKey].filters.open);
    var filterSummary = el('summary', '', 'Filters & sort'); append(filters, filterSummary); append(form, filters);
    var prices = el('div', 'fb-group__price-fields');
    var min = field(prices, 'catalogue-min-price', 'Minimum item price ($ AUD)', 'number', state.query.minPriceCents == null ? '' : state.query.minPriceCents / 100, { min: 0, step: '0.01', inputmode: 'decimal' });
    var max = field(prices, 'catalogue-max-price', 'Maximum item price ($ AUD)', 'number', state.query.maxPriceCents == null ? '' : state.query.maxPriceCents / 100, { min: 0, step: '0.01', inputmode: 'decimal' });
    append(filters, prices);
    var sortLabel = el('label', '', 'Sort gifts'); sortLabel.htmlFor = 'group-catalogue-sort';
    var sort = el('select'); sort.id = 'group-catalogue-sort'; sort.name = 'catalogue-sort';
    [['recommended', 'Recommended'], ['price_asc', 'Price: low to high'], ['price_desc', 'Price: high to low']].forEach(function (choice) {
      var option = el('option', '', choice[1]); option.value = choice[0]; append(sort, option);
    });
    sort.value = state.query.sort;
    var validation = el('p', 'fb-group__error fb-group__error-summary'); validation.setAttribute('role', 'alert'); validation.tabIndex = -1; validation.hidden = true;
    function apply() {
      var minCents = price(String(min.value)), maxCents = price(String(max.value));
      if (minCents === undefined || maxCents === undefined || (minCents !== null && maxCents !== null && minCents > maxCents)) {
        filters.open = true;
        var rejected = minCents === undefined ? ['catalogue-min-price'] : maxCents === undefined ? ['catalogue-max-price'] : ['catalogue-min-price', 'catalogue-max-price'];
        formError(form, 'Enter valid item prices, with the minimum no higher than the maximum.', rejected); return;
      }
      clearFormErrors(form);
      categoryButtons.forEach(function (choice) { choice.element.setAttribute('aria-pressed', String(choice.id === category)); });
      return catalogue.search({ q: search.value, category: category, sort: sort.value, minPriceCents: minCents, maxPriceCents: maxCents });
    }
    function clear() { search.value = ''; min.value = ''; max.value = ''; category = 'all'; sort.value = 'recommended'; return apply(); }
    var submit = button('Apply filters'); submit.type = 'submit';
    form.addEventListener('submit', function (event) { event.preventDefault(); return apply(); });
    append(filters, sortLabel, sort);
    append(form, validation, append(el('div', 'fb-group__actions'), submit, button('Clear filters', clear, true)));
    var targetCents = setup ? (setup.getTargetCents ? setup.getTargetCents() : null) : this.group.targetCents;
    if (!setup || Number.isSafeInteger(targetCents)) {
      var shortcuts = el('div', 'fb-group__actions');
      if (Number.isSafeInteger(targetCents)) append(shortcuts, button('Up to the target · ' + money(targetCents), function () { max.value = targetCents / 100; return apply(); }, true));
      if (!setup) {
        var available = this.group.budget && this.group.budget.availableCents;
        var funds = button('Up to available funds · ' + money(available), function () { max.value = self.group.budget.availableCents / 100; return apply(); }, true);
        funds.disabled = !Number.isSafeInteger(available); append(shortcuts, funds);
      }
      append(filters, shortcuts);
    }
    var grid = el('div', 'fb-group__catalogue-grid'); grid.setAttribute('aria-label', 'Gift results');
    var status = el('p', 'fb-group__status'); status.setAttribute('role', 'status');
    var more = button('Load more', function () {
      return catalogue.state.needsRefresh || (catalogue.state.error && catalogue.state.nextOffset === null) ? catalogue.refresh() : catalogue.more();
    }, true);
    this[viewKey] = { grid: grid, status: status, more: more, clear: clear, filters: filters, filterSummary: filterSummary };
    append(section, form, status, grid, more); append(container, section);
    this.renderCatalogueResults(setup);
    if (!state.loadedPages && !state.loading) catalogue.refresh();
  };
  Controller.prototype.renderCatalogueResults = function (setup) {
    var catalogue = setup ? this.setupCatalogue : this.catalogue, view = setup ? this.setupCatalogueView : this.catalogueView;
    if (!catalogue || !view) return;
    var state = catalogue.state, self = this;
    // Save acknowledged public browsing state even when no detail panel opens.
    // Loading/error states and setup context must not replace the last saved query.
    if (!setup && !this.restoringRoute && !state.loading && !state.error && state.loadedPages && root.history && root.location.href) {
      var route = new URL(root.location.href);
      if (route.searchParams.get('reminder_view') === 'group' && route.searchParams.get('id') === this.id && route.searchParams.get('group_section') === 'gifts') {
        root.history.replaceState({ fbGroupCatalogue: catalogue.snapshot(), fbGroupScrollY: root.scrollY || 0 }, '', route.href);
      }
    }
    var applied = [];
    if (state.query.minPriceCents != null) applied.push('From ' + money(state.query.minPriceCents));
    if (state.query.maxPriceCents != null) applied.push('Up to ' + money(state.query.maxPriceCents));
    if (state.query.sort !== 'recommended') applied.push(state.query.sort === 'price_asc' ? 'Price: low to high' : 'Price: high to low');
    if (view.filterSummary) view.filterSummary.textContent = 'Filters & sort' + (applied.length ? ' · ' + applied.join(' · ') : '');

    view.grid.textContent = '';
    view.grid.setAttribute('aria-busy', String(state.loading));
    state.products.forEach(function (product) { append(view.grid, self.productCard(product, null, setup ? { context: setup, onDetails: function () { return self.productDrawer(product, null, setup); } } : null)); });
    if (!state.loading && !state.error && !state.products.length) append(view.grid,
      el('p', '', 'No gifts match these filters'), button('Clear filters', view.clear, true));
    view.status.textContent = state.error ? (state.needsRefresh ? 'The catalogue changed. Refresh results to continue.' : 'Couldn’t load gifts. Try again.')
      : state.loading ? 'Finding gifts…' : state.total + (state.total === 1 ? ' gift found' : ' gifts found');
    view.more.textContent = state.needsRefresh ? 'Refresh results' : state.error ? 'Try again' : 'Load more';
    view.more.hidden = !state.error && state.nextOffset === null;
    view.more.disabled = state.loading;
  };
  Controller.prototype.loadProducts = function () { if (this.catalogue) return this.catalogue.more(); };
  Controller.prototype.inviteDrawer = function () {
    var self = this;
    var g = this.group;
    var body = this.openDrawer('Preview your invitation');
    append(
      body,
      el(
        'p',
        'fb-group__muted',
        'Previewing does not send an invitation. You choose who receives the link.'
      )
    );
    var preview = el('div', 'fb-group__context');
    append(
      preview,
      el('h3', '', g.name),
      el(
        'p',
        '',
        g.organiserName + ' is organising a gift for ' + g.recipientName + '.'
      ),
      el(
        'p',
        '',
        date(g.occasion.occursOn) +
          (g.occasion.recurrence === 'once' ? ' · One-off occasion' : '')
      ),
      el('p', '', 'Contribute by ' + date(g.deadlineAt, true)),
      pair('Target', money(g.budget.targetCents))
    );
    append(
      body,
      preview,
      el(
        'p',
        'fb-group__notice',
        'Keep the surprise. Share with the people giving the gift, not the recipient.'
      )
    );
    var get = button(
      g.state === 'draft'
        ? 'Open contributions'
        : 'Get invitation link',
      function () {
        if (g.state === 'draft') return self.openGroupDrawer();
        self.perform(
          async function () {
            var response = await self.request(self.endpoint('/invitations'), {
              idempotencyKey: self.key('invite', { id: g.id }),
              rotate: false
            });
            self.inviteLink(body, response.url);
            if (response.group) self.group = response.group;
            self.notify('Your invitation is ready. No message has been sent.');
            get.hidden = true;
          },
          get,
          'Preparing the invitation…'
        );
      }
    );
    append(body, append(el('div', 'fb-group__actions'), get));
    if (g.state === 'open')
      append(
        body,
        button(
          'Replace previous invitation link',
          function () {
            self.perform(
              async function () {
                var response = await self.request(
                  self.endpoint('/invitations'),
                  {
                    idempotencyKey: self.key('rotate', { id: g.id }),
                    rotate: true
                  }
                );
                self.inviteLink(body, response.url);
                delete self.keys.rotate;
                delete self.keys.invite;
                self.notify(
                  'The previous link no longer accepts new joins. Current members keep access.'
                );
              },
              null,
              'Replacing the invitation link…'
            );
          },
          true
        )
      );
  };
  Controller.prototype.inviteLink = function (body, url) {
    var self = this;
    var parsed;
    try {
      parsed = new URL(url, root.location.origin);
      if (
        parsed.origin !== root.location.origin ||
        parsed.pathname !== '/pages/reminders' ||
        parsed.searchParams.get('reminder_view') !== 'group-invite'
      )
        throw new Error();
    } catch (_) {
      throw new Error(
        'The invitation link could not be verified. Please try again.'
      );
    }
    var previous = body.querySelector('[data-group-invitation-link]');
    if (previous) previous.remove();
    var panel = el('div');
    panel.dataset.groupInvitationLink = '';
    var input = field(
      panel,
      'share',
      'Private invitation link',
      'text',
      parsed.href,
      { readonly: '' }
    );
    var copy = button('Copy invitation link', async function () {
      try {
        await root.navigator.clipboard.writeText(input.value);
        self.notify('Invitation link copied. Share it with your group.');
      } catch (_) {
        input.focus();
        input.select();
        self.notify('Select and copy the invitation link above.');
      }
    });
    append(panel, append(el('div', 'fb-group__actions'), copy));
    append(body, panel);
  };
  Controller.prototype.confirmDrawer = function (
    title,
    explanation,
    actionText,
    tail
  ) {
    var self = this;
    var body = this.openDrawer(title);
    append(body, el('p', '', explanation));
    var confirm = button(actionText, function () {
      self.perform(
        async function () {
          var result = await self.request(self.endpoint(tail), {
            idempotencyKey: self.key(tail, { id: self.id })
          });
          self.closeDrawer();
          if (result.group) self.group = result.group;
          await self.load();
          self.notify('Status updated. Check the details below.');
        },
        confirm,
        'Updating the group…'
      );
    });
    append(
      body,
      append(
        el('div', 'fb-group__actions'),
        confirm,
        button(
          'Keep as it is',
          function () {
            self.closeDrawer();
          },
          true
        )
      )
    );
  };
  Controller.prototype.contributionDrawer = function () {
    var self = this;
    var body = this.openDrawer(
      'Contribute to ' + this.group.recipientName + '’s gift'
    );
    if (!this.group.permissions.canContribute || !hasTerms(this.terms)) {
      append(
        body,
        el(
          'p',
          '',
          'Contributions are not available right now. Refresh the group to check its status.'
        )
      );
      return;
    }
    append(
      body,
      el(
        'p',
        '',
        'Your contribution joins the group fund. ' +
          this.group.organiserName +
          ' chooses and orders the gift.'
      )
    );
    var form = el('form');
    form.id = 'group-contribution-form';
    var amount = field(form, 'amount', 'Your contribution ($)', 'text', '', {
      inputmode: 'decimal',
      required: '',
      autocomplete: 'off'
    });
    append(
      form,
      el('p', '', 'Contribute by ' + date(this.group.deadlineAt, true))
    );
    if (this.group.purchaseDeadlineAt)
      append(
        form,
        el('p', '', 'Order by ' + date(this.group.purchaseDeadlineAt, true))
      );
    append(form, termsBlock(this.terms));
    var check = el('label', 'fb-group__check');
    var agreed = el('input');
    agreed.type = 'checkbox';
    agreed.name = 'agreed';
    agreed.required = true;
    wireFieldValidation(agreed, 'Contribution and refund terms');
    append(
      check,
      agreed,
      el('span', '', 'I agree to these contribution and refund terms.')
    );
    append(form, check);
    var submit = button('Continue to secure payment');
    submit.type = 'submit';
    submit.setAttribute('form', form.id);
    append(
      form,
      el(
        'p',
        'fb-group__muted',
        'Stripe will show your payment details before you pay. A pending payment does not increase the group’s available funds.'
      )
    );
    append(body, form);
    append(this.dialog, append(el('div', 'fb-group__dialog-footer'), submit));
    amount.focus();
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      var value = cents(amount.value);
      if (value === null) {
        formError(form, 'Enter an amount in dollars and cents.', ['amount']);
        return;
      }
      var payload = { amountCents: value, termsVersion: self.terms.version };
      payload.idempotencyKey = self.key('contribute', payload);
      self.perform(
        async function () {
          amount.disabled = true;
          agreed.disabled = true;
          try {
            var result = await self.request(
              self.endpoint('/contributions'),
              payload
            );
            var c = result.contribution;
            if (!c || !c.id)
              throw new Error(
                'We could not confirm the payment attempt. Retry to recover the same attempt.'
              );
            var url = c && safeCheckout(c.checkoutUrl, 'contribution');
            if (url) {
              root.location.assign(url);
              return;
            }
            if (c && c.state === 'failed') {
              delete self.keys.contribute;
              self.notify(
                'That payment was unsuccessful. Try again to start a new secure payment.',
                true
              );
              return;
            }
            if (c && c.state === 'succeeded') {
              self.closeDrawer();
              await self.load();
              self.notify('Contribution received.');
              return;
            }
            self.notify(
              'Your payment is being prepared. Check status before trying again.'
            );
            var checkStatus = button(
              'Check payment status',
              function (ev) {
                self.perform(
                  async function () {
                    await self.request(
                      self.endpoint(
                        '/contributions/' + encodeURIComponent(c.id)
                      )
                    );
                    self.closeDrawer();
                    await self.load();
                  },
                  ev.currentTarget,
                  'Checking payment status…'
                );
              },
              true
            );
            append(body, checkStatus);
            submit.dataset.groupLocked = 'true';
            submit.disabled = true;
          } finally {
            if (submit.dataset.groupLocked !== 'true') {
              amount.disabled = false;
              agreed.disabled = false;
            }
          }
        },
        submit,
        'Preparing secure payment…'
      );
    });
  };
  Controller.prototype.receiptEmailPanel = function (body) {
    if (body.querySelector('[data-group-receipt-email]')) return;
    var self = this;
    var box = el('section', 'fb-group__section');
    box.dataset.groupReceiptEmail = '';
    append(
      box,
      el('h3', '', 'Verify your receipt email'),
      el(
        'p',
        '',
        'Add a verified email to this same account for the order receipt. Your group and delivery details stay here.'
      )
    );
    var form = el('form');
    field(form, 'receiptEmail', 'Your email address', 'email', '', {
      required: '',
      autocomplete: 'email'
    });
    var send = button('Send verification link');
    send.type = 'submit';
    append(form, append(el('div', 'fb-group__actions'), send));
    append(box, form);
    var checked = button(
      'I’ve confirmed my email',
      function () {
        self.perform(
          async function () {
            var result = await self.request(self.endpoint('/receipt-email'));
            if (result.verified) {
              box.remove();
              self.notify('', true);
              self.notify(
                'Email verified. Check the total and delivery again to continue.'
              );
            } else
              self.notify(
                'We’re still waiting for verification. Open the link in your email, then check again.'
              );
          },
          checked,
          'Checking your email…'
        );
      },
      true
    );
    append(box, checked);
    append(body, box);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      self.perform(
        async function () {
          await self.request(self.endpoint('/receipt-email'), {
            email: form.elements.receiptEmail.value.trim()
          });
          self.notify(
            'Check your email for the verification link, then return here.'
          );
        },
        send,
        'Sending your verification link…'
      );
    });
  };
  Controller.prototype.quoteDrawer = function (step, restoring) {
    var self = this, g = this.group;
    if (!g || g.role !== 'organiser') return;
    var body = this.openDrawer('Delivery & review');
    this.quoteRevision = (this.quoteRevision || 0) + 1;
    var plan = g.plan;
    if (g.state !== 'closed' || !plan || !plan.initialized || !plan.items.length || plan.confirmedVersion !== plan.version) {
      append(body, el('p', '', 'Review and confirm the saved gifts before arranging delivery.'), button('Review shortlist', function () { self.navigateSection('shortlist'); }, true)); return;
    }
    append(body, el('p', '', 'Only you can see delivery details. Nothing is ordered until you review the total and place the group order.'));
    var estimate = el('div', 'fb-group__plan-summary');
    plan.items.forEach(function (item) { append(estimate, el('p', '', item.product.title + ' · ' + item.product.variantLabel + ' · ' + money(item.product.priceCents))); });
    append(estimate, pair('Item estimate', money(plan.itemSubtotalCents)), el('p', 'fb-group__muted', 'Delivery is checked next.'), pair('Confirmed funds', money(g.budget.availableCents))); append(body, estimate);
    if (!g.permissions.canQuote) {
      append(body, el('p', '', 'Delivery cannot be reviewed yet. Check the group’s next action or change the gifts.'));
      if (g.journey && g.journey.primaryAction.id === 'verify_receipt_email') this.receiptEmailPanel(body);
      append(body, button('Back to group', function () { self.navigateSection('overview'); }, true)); return;
    }
    if (!restoring && (step === 'delivery' || step === 'review')) this.writeJourneyStepRoute(step);
    var stage = el('h3', '', '1 Delivery'), form = el('form'), delivery = el('fieldset');
    append(body, stage);
    var saved = this.deliveryDraft && this.deliveryDraft.groupId === g.id && this.deliveryDraft.identity === this.identityVersion ? this.deliveryDraft.selection : this.savedSelection || {};
    var address = saved.shippingAddress || {};
    append(delivery, el('p', '', 'Deliver to ' + g.recipientName));
    field(delivery, 'address1', 'Address', 'text', address.address1 || '', {
      required: '',
      autocomplete: 'address-line1'
    });
    field(
      delivery,
      'address2',
      'Apartment or unit (optional)',
      'text',
      address.address2 || '',
      { autocomplete: 'address-line2' }
    );
    field(delivery, 'city', 'Suburb or city', 'text', address.city || '', {
      required: '',
      autocomplete: 'address-level2'
    });
    var locality = el('div', 'fb-group__form-grid');
    var stateField = el('div', 'fb-group__field');
    var stateLabel = el('label', '', 'State');
    stateLabel.htmlFor = 'group-province';
    var stateSelect = el('select');
    stateSelect.id = 'group-province';
    stateSelect.name = 'province';
    stateSelect.required = true;
    wireFieldValidation(stateSelect, 'State');
    ['', 'ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'].forEach(
      function (state) {
        append(stateSelect, new Option(state || 'Choose state', state));
      }
    );
    stateSelect.value = address.province || '';
    append(stateField, stateLabel, stateSelect);
    append(locality, stateField);
    field(locality, 'zip', 'Postcode', 'text', address.zip || '', {
      required: '',
      autocomplete: 'postal-code',
      inputmode: 'numeric',
      pattern: '[0-9]{4}'
    });
    append(delivery, locality);
    field(
      delivery,
      'phone',
      'Recipient phone (optional)',
      'tel',
      address.phone || '',
      { autocomplete: 'tel', maxlength: '30' }
    );
    field(
      delivery,
      'deliveryOn',
      'Delivery date',
      'date',
      saved.deliveryOn || g.occasion.occursOn,
      { required: '' }
    );
    field(
      delivery,
      'giftMessage',
      'Message for the gift (optional)',
      'textarea',
      saved.giftMessage || '',
      { maxlength: '2000' }
    );
    var submit = button('Check delivery & total'); submit.type = 'submit';
    var output = el('section', 'fb-group__section'); output.dataset.groupQuoteOutput = '';
    append(form, delivery, append(el('div', 'fb-group__actions'), submit), output); append(body, form);
    function draft() {
      return { deliveryOn: form.elements.deliveryOn.value, giftMessage: form.elements.giftMessage.value.trim(), shippingAddress: {
        address1: form.elements.address1.value.trim(), address2: form.elements.address2.value.trim(), city: form.elements.city.value.trim(), province: form.elements.province.value,
        zip: form.elements.zip.value.trim(), countryCode: 'AU', phone: form.elements.phone.value.trim() } };
    }
    function remember() { self.deliveryDraft = { groupId: g.id, identity: self.identityVersion, selection: draft() }; }
    function showDelivery() {
      self.quoteRevision++; self.quote = null; output.textContent = '';
      self.writeJourneyStepRoute('delivery');
      form.hidden = false; stage.textContent = '1 Delivery'; delivery.hidden = false; delivery.disabled = false; submit.hidden = false;
      stage.tabIndex = -1; stage.focus();
    }
    function showReview(selection) {
      if (selection) {
        var address = selection.shippingAddress || {};
        ['address1', 'address2', 'city', 'province', 'zip', 'phone'].forEach(function (name) { form.elements[name].value = address[name] || ''; });
        form.elements.deliveryOn.value = selection.deliveryOn || '';
        form.elements.giftMessage.value = selection.giftMessage || '';
      }
      self.writeJourneyStepRoute('review');
      remember(); stage.textContent = '2 Review order'; delivery.hidden = true; delivery.disabled = true; submit.hidden = true;
      stage.tabIndex = -1; stage.focus();
    }
    function hidePrivate() { self.quoteRevision++; self.quote = null; output.textContent = ''; form.hidden = true; }
    this.reviewView = { groupId: g.id, planVersion: plan.version, hidePrivate: hidePrivate, identity: this.identityVersion, drawerVersion: this.drawerVersion, output: output, showDelivery: showDelivery, showReview: showReview };
    this.resumeDelivery = showDelivery;
    form.addEventListener('input', function () { remember(); self.quoteRevision++; self.quote = null; output.textContent = ''; });
    form.addEventListener('submit', function (event) {
      event.preventDefault(); if (!form.reportValidity()) return; remember();
      return self.getQuote(draft(), output, submit);
    });
    var existing = this.quoteSnapshot;
    if (step === 'review' && existing && existing.quote && existing.quote.planVersion === plan.version && existing.quote.reviewVersion === existing.reviewVersion)
      this.renderQuoteReview(existing.quote, existing.selection, output);
  };
  Controller.prototype.getQuote = function (payload, output, submit) {
    var self = this, revision = this.quoteRevision, identity = this.identityVersion, drawer = this.drawerVersion, groupId = this.id;
    function current() { return identity === self.identityVersion && drawer === self.drawerVersion && groupId === self.id && output.isConnected && self.dialog.open; }
    payload.expectedPlanVersion = this.group.plan.version;
    payload.expectedReviewVersion = this.quoteSnapshot ? this.quoteSnapshot.reviewVersion : 0;
    payload.idempotencyKey = this.key('quote', payload);
    this.quote = null; output.textContent = '';
    return this.perform(async function () {
      try {
        await self.requestPlanning(self.endpoint('/quote'), payload);
        if (!current()) return;
        var saved = await self.request(self.endpoint('/quote'));
        if (!current()) return;
        var projection = await self.request(self.endpoint());
        if (!current()) return;
        var group = projection.group || projection;
        self.group = group; self.quoteSnapshot = saved; self.savedSelection = saved.selection || null; self.renderGroup();
        if (self.quoteRevision !== revision) return;
        if (group.role !== 'organiser' || group.state !== 'closed' || !group.permissions.canQuote || group.plan.version !== saved.planVersion) {
          self.quote = null; submit.disabled = true; submit.dataset.groupLocked = 'true';
          if (group.role !== 'organiser' && self.reviewView) self.reviewView.hidePrivate();
          append(output, el('p', 'fb-group__error', 'The group changed while delivery was checked. Review its current status before continuing.'), button('Review current group', function () { self.closeDrawer(); self.load(); }, true)); return;
        }
        if (!saved.quote) { append(output, el('p', 'fb-group__error', 'The saved review changed or expired. Check delivery and total again.')); return; }
        self.renderQuoteReview(saved.quote, saved.selection, output);
      } catch (error) {
        if (!current() || self.quoteRevision !== revision) return;
        if (error.code === 'UNAUTHENTICATED' && self.reviewView) self.reviewView.hidePrivate();
        if (error.code === 'EDIT_CONFLICT') {
          var latest = await self.request(self.endpoint('/quote'));
          if (!current() || self.quoteRevision !== revision) return;
          self.quoteSnapshot = latest; self.savedSelection = latest.selection || null;
          var message = el('p', 'fb-group__error', 'The saved gifts or delivery changed in another session. Your unsaved delivery fields are kept. Review the current saved delivery, or check your details and submit again.');
          message.setAttribute('role', 'alert'); append(output, message);
          if (latest.planVersion !== self.group.plan.version) {
            submit.disabled = true; submit.dataset.groupLocked = 'true';
            append(output, button('Review current gifts', function () { self.closeDrawer(); self.load(); }, true));
          } else if (latest.quote) append(output, button('Review current saved delivery', function () { self.renderQuoteReview(latest.quote, latest.selection, output); }, true));
          return;
        }
        throw error;
      }
    }, submit, 'Checking current prices, stock and delivery…');
  };
  Controller.prototype.renderQuoteReview = function (q, payload, output) {
    var self = this;
    self.quote = q;
    output.textContent = '';
    append(output, el('h3', '', 'Your order total'));
    (q.lines || []).forEach(function (line) {
      append(
        output,
        pair(
          (line.title || (self.group.plan.items.find(function (item) { return item.variantId === line.variantId; }) || {}).product?.title || 'Gift') + ' · ' + (line.variantLabel || (self.group.plan.items.find(function (item) { return item.variantId === line.variantId; }) || {}).product?.variantLabel || 'Option not recorded') +
            ' × ' +
            line.quantity,
          money(line.unitCents * line.quantity)
        )
      );
    });
    if (
      q.shippingRates &&
      q.shippingRates.length &&
      !payload.shippingRateHandle
    ) {
      append(
        output,
        el('p', '', 'Choose a delivery option to confirm the total.')
      );
      q.shippingRates.forEach(function (rate) {
        append(
          output,
          button(
            rate.title + ' · ' + money(rate.priceCents),
            function (event) {
              var next = { ...payload, shippingRateHandle: rate.handle };
              delete next.idempotencyKey;
              self.getQuote(next, output, event.currentTarget);
            },
            true
          )
        );
      });
      return;
    }
    if (self.reviewView && self.reviewView.output === output) self.reviewView.showReview(payload);
    var address = payload && payload.shippingAddress || {};
    append(output, el('h3', '', 'Delivery details'), el('p', '', 'Deliver to ' + self.group.recipientName),
      el('p', '', [address.address1, address.address2, address.city, address.province, address.zip].filter(Boolean).join(', ')),
      el('p', '', 'Delivery on ' + date(payload.deliveryOn)),
      payload.giftMessage ? el('p', '', 'Gift message: ' + payload.giftMessage) : null,
      pair('Confirmed funds', money(q.availableCents == null ? self.group.budget.availableCents : q.availableCents)),
      append(el('div', 'fb-group__actions'), button('Edit delivery', function () { if (self.reviewView) self.reviewView.showDelivery(); }, true),
        button('Edit gifts', function () { self.quote = null; self.quoteRevision++; self.navigateSection('shortlist'); }, true)));
    append(
      output,
      pair(
        'Delivery',
        q.deliveryCents == null ? 'Not yet quoted' : money(q.deliveryCents)
      ),
      pair('Total', money(q.totalCents))
    );
    if (q.taxCents)
      append(
        output,
        el(
          'p',
          'fb-group__muted',
          'Includes ' + money(q.taxCents) + ' tax.'
        )
      );
    if (q.expiresAt)
      append(
        output,
        el(
          'p',
          'fb-group__muted',
          'Quote valid until ' + date(q.expiresAt, true)
        )
      );
    if (q.message) append(output, el('p', '', q.message));
    if (q.expiresAt && !(new Date(q.expiresAt).getTime() > Date.now())) {
      self.quote = null;
      append(output, el('p', 'fb-group__error', 'This quote has expired. Check delivery and total again before ordering.'),
        button('Check delivery again', function () { if (self.reviewView) self.reviewView.showDelivery(); }, true));
      return;
    }
    if (q.shortfallCents > 0) {
      append(
        output,
        el(
          'p',
          '',
          'This gift needs another ' +
            money(q.shortfallCents) +
            '. Choose a different gift or use the organiser top-up option if available.'
        )
      );
      if (q.canTopUp)
        append(
          output,
          button('Top up ' + money(Math.max(100, q.shortfallCents)), function () {
            self.topUp(q);
          })
        );
      return;
    }
    if (
      q.ready === true &&
      q.id &&
      q.deliveryCents != null &&
      q.totalCents > 0
    ) {
      var buy = button('Place group order · ' + money(q.totalCents), function () {
        if (self.quote !== q || !self.dialog.open || !output.isConnected || self.group.role !== 'organiser' || self.group.plan.version !== q.planVersion) return;
        if (q.expiresAt && !(new Date(q.expiresAt).getTime() > Date.now())) { self.renderQuoteReview(q, payload, output); return; }
        return self.purchaseReviewedQuote(q, output, buy);
      });
      append(
        output,
        append(el('div', 'fb-group__actions'), buy),
        el(
          'p',
          'fb-group__muted',
          'Placing this order spends the group’s confirmed funds and locks withdrawals while we place it with Shopify. The order is confirmed only when Shopify reports it paid. No additional payment will be taken.'
        )
      );
    }
  };
  Controller.prototype.purchaseReviewedQuote = function (q, output, control, attempt) {
    var self = this, identity = this.identityVersion, drawer = this.drawerVersion, groupId = this.id;
    attempt = attempt || { quoteId: q.id, idempotencyKey: this.key('purchase', { quoteId: q.id }) };
    function current() { return identity === self.identityVersion && drawer === self.drawerVersion && groupId === self.id && self.dialog.open && output.isConnected; }
    function paused(group) {
      return Object.assign({}, group, { permissions: Object.assign({}, group.permissions, {
        canEditPlan: false, canSelectGift: false, canConfirmPlan: false, canQuote: false, canPurchase: false,
        canSuggest: false, canComment: false, canTopUp: false, canOpen: false, canClose: false, canShareInvitation: false
      }) });
    }
    return this.perform(async function () {
      var response;
      // A dispatched order may already exist. Pause local planning until this
      // same attempt returns an authoritative outcome; do not invent a lifecycle.
      self.group = paused(self.group); self.renderGroup();
      try {
        response = await self.request(self.endpoint('/purchase'), attempt);
        if (!response || !response.purchase || !response.purchase.id) throw { code: 'NETWORK_ERROR', message: 'We could not confirm the order response.' };
      }
      catch (error) {
        if (!current()) {
          if (identity === self.identityVersion && groupId === self.id) await self.load();
          return;
        }
        self.quote = null; self.quoteRevision++; output.textContent = '';
        if (error.code === 'UNAUTHENTICATED') { if (self.reviewView) self.reviewView.hidePrivate(); throw error; }
        if (error.code && error.code !== 'NETWORK_ERROR' && !(error.status >= 500)) {
          append(output, button('Review current delivery and gifts', function () { self.closeDrawer(); self.load(); }, true));
          throw error;
        }
        try {
          var refreshed = await self.request(self.endpoint());
          if (identity !== self.identityVersion || groupId !== self.id) return;
          self.group = paused(refreshed.group || refreshed); self.renderGroup();
          if (!current()) return;
          if (self.group.role !== 'organiser') { if (self.reviewView) self.reviewView.hidePrivate(); return; }
        } catch (statusError) {
          if (!current()) return;
          if (['UNAUTHENTICATED', 'FORBIDDEN', 'NOT_FOUND'].includes(statusError.code)) {
            if (self.reviewView) self.reviewView.hidePrivate();
            throw statusError;
          }
          // Offline recovery keeps the local planning pause and original key.
        }
        var message = el('p', 'fb-group__error', 'We could not confirm the order response. It may have been placed. Check this same attempt before making any changes.');
        message.setAttribute('role', 'alert');
        var retry = button('Check this order attempt', function () { return self.purchaseReviewedQuote(q, output, retry, attempt); });
        append(output, message, retry); return;
      }
      if (identity !== self.identityVersion || groupId !== self.id) return;
      var purchase = response.purchase;
      if (current()) self.closeDrawer();
      await self.load();
      if (identity !== self.identityVersion || groupId !== self.id || !self.group || self.group.role !== 'organiser') return;
      if (!self.group.purchase && purchase) { self.group.purchase = purchase; self.renderGroup(); }
      purchase = self.group.purchase || purchase;
      self.notify(purchase && purchase.state === 'completed' ? 'Your group gift order is confirmed.'
        : purchase && purchase.state === 'failed' ? 'The order was not placed. Check the current funds and review the gift before trying again.'
        : purchase && purchase.state === 'review_required' ? 'Your order needs attention. Contact Fig & Bloom support before trying again.'
        : purchase && ['pending', 'preparing'].includes(purchase.state) ? 'We’re checking your order. Your funds remain reserved until its status is confirmed.'
        : 'Check the current order status before trying again.');
    }, control, 'Checking the same order attempt…');
  };
  Controller.prototype.topUp = function (quote) {
    var self = this;
    if (this.group.role !== 'organiser' || !hasTerms(this.terms)) return;
    var amountCents = Math.max(100, quote.shortfallCents);
    var body = this.openDrawer('Top up your group gift');
    append(
      body,
      el(
        'p',
        '',
        amountCents > quote.shortfallCents
          ? 'The remaining shortfall is ' +
            money(quote.shortfallCents) +
            '. The minimum top-up is $1. Add $1 to cover it. Any unused group funds after purchase are refunded proportionally to the original payment methods.'
          : 'Add ' + money(amountCents) + ' to cover the confirmed total.'
      ),
      termsBlock(this.terms)
    );
    var form = el('form');
    form.id = 'group-topup-form';
    var label = el('label', 'fb-group__check');
    var agreed = el('input');
    agreed.type = 'checkbox';
    agreed.name = 'agreed';
    agreed.required = true;
    wireFieldValidation(agreed, 'Contribution and refund terms');
    append(
      label,
      agreed,
      el('span', '', 'I agree to these contribution and refund terms.')
    );
    var submit = button('Continue to secure payment');
    submit.type = 'submit';
    submit.setAttribute('form', form.id);
    append(form, label);
    append(body, form);
    append(this.dialog, append(el('div', 'fb-group__dialog-footer'), submit));
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      self.perform(
        async function () {
          var payload = {
            amountCents: amountCents,
            termsVersion: self.terms.version,
            quoteId: quote.id,
            topUp: true
          };
          payload.idempotencyKey = self.key('topup', payload);
          var result = await self.request(
            self.endpoint('/contributions'),
            payload
          );
          var contribution = result.contribution;
          if (!contribution || !contribution.id)
            throw new Error(
              'We could not confirm your top-up attempt. Retry to recover the same attempt.'
            );
          if (contribution.state === 'failed') {
            delete self.keys.topup;
            self.notify(
              'That payment was unsuccessful. Try again to start a new secure payment.',
              true
            );
            return;
          }
          var url = safeCheckout(contribution.checkoutUrl, 'contribution');
          if (url) root.location.assign(url);
          else {
            self.closeDrawer();
            await self.load();
            self.notify(
              'Check your top-up status before starting another payment.'
            );
          }
        },
        submit,
        'Preparing your top-up…'
      );
    });
  };
  return {
    init: function (page) {
      var controller = new Controller(page);
      activeController = controller;
      controller.load();
      return controller;
    },
    invitationToken: function () {
      return activeController && activeController.view === 'group-invite'
        ? activeController.token
        : null;
    },
    _test: {
      Controller: Controller,
      cents: cents,
      money: money,
      safeCheckout: safeCheckout,
      safeProductUrl: safeProductUrl,
      safeImage: safeImage,
      hasTerms: hasTerms,
      PAYMENT_STATES: PAYMENT_STATES
    }
  };
});
